function syncAmpmBundleCardState(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.js-ampm-bundle-card').each(function () {
        var card = jQuery(this);
        var isActive = card.find('.js-ampm-bundle-heading').hasClass('active');
        card.toggleClass('is-active', isActive);
    });
}

function getSelectedPurchaseTab(wrapper, fallbackRoot) {
    var selectedTab = '';
    var defaultTab = '';

    if (wrapper && wrapper.length) {
        selectedTab = wrapper.attr('data-selected-purchase-tab') || '';
        defaultTab = wrapper.attr('data-default-purchase-tab') || '';
    }

    if (!selectedTab) {
        var searchRoot = fallbackRoot && fallbackRoot.length ? fallbackRoot : wrapper;
        var activeHeading = searchRoot && searchRoot.length
            ? searchRoot.find('.custom_widget_subscription_heading_item.active').first()
            : jQuery();

        if (activeHeading.length) {
            selectedTab = activeHeading.attr('data_tab') || '';
        }
    }

    return selectedTab || defaultTab || '1';
}

function syncSubscriptionContentState(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.custom_widget_subscription').each(function () {
        var subscriptionCard = jQuery(this);
        var subscriptionDetails = subscriptionCard.find('.custom_widget_subscription_content[data_tab="1"]');
        var wrapper = subscriptionCard.closest('.custom_boc_subscripe_full');
        var oneTimeContent = subscriptionCard.find('.custom_widget_subscription_content[data_tab="2"]').first();
        if (!oneTimeContent.length && wrapper.length) {
            oneTimeContent = wrapper.find('.custom_widget_subscription_content--v9-one-time[data_tab="2"]').first();
        }
        var keepSubscribeOpenOnOneTimeClick = wrapper.attr('data-keep-subscribe-open-on-one-time-click') === 'true';
        var keepPrimaryVisibleForOtp = keepSubscribeOpenOnOneTimeClick;
        var currentTab = getSelectedPurchaseTab(wrapper, subscriptionCard);
        if (wrapper.length) {
            wrapper.toggleClass('is-subscribe-tab-active', currentTab === "1" || (keepSubscribeOpenOnOneTimeClick && currentTab === "2"));
            wrapper.toggleClass('is-one-time-selected', currentTab === "2");
            wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').toggleClass('is-open', currentTab === "1" || (keepSubscribeOpenOnOneTimeClick && currentTab === "2"));
            wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').toggleClass('is-selected', currentTab === "1");
            wrapper.find('.js-one-time-card').toggleClass('is-selected', currentTab === "2");
            wrapper.find('.js-one-time-card .custom_widget_subscription_heading_item').toggleClass('is-selected', currentTab === "2");
        }

        if (currentTab === "1") {
            subscriptionDetails.show();
            if (oneTimeContent.length) oneTimeContent.hide();
        } else if (currentTab === "2") {
            if (keepPrimaryVisibleForOtp) {
                subscriptionDetails.show();
            } else {
                subscriptionDetails.hide();
            }
            if (oneTimeContent.length) oneTimeContent.hide();
        } else {
            subscriptionDetails.hide();
            if (oneTimeContent.length) oneTimeContent.hide();
        }
    });
}

function syncBetweenOptionsTextState(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.custom_boc_subscripe_full').each(function () {
        var wrapper = jQuery(this);
        var betweenText = wrapper.find('.custom_widget_subscription_between_text');
        if (!betweenText.length) return;

        var showOnlyOneTime = betweenText.attr('data-show-one-time-only') === 'true';
        if (!showOnlyOneTime) {
            betweenText.show();
            return;
        }

        var hasSubscribeOption = wrapper.find('.custom_widget_subscription_heading_item[data_tab="1"]').length > 0;
        var selectedTab = getSelectedPurchaseTab(wrapper, wrapper);
        var shouldShow = false;

        if (selectedTab) {
            shouldShow = selectedTab === '2';
        } else if (!hasSubscribeOption) {
            // One-time only products should keep helper text visible.
            shouldShow = true;
        }

        betweenText.toggle(shouldShow);
    });
}

function getAtcSubFrequencyValue(wrapper, tab) {
    if (!wrapper || !wrapper.length) {
        return 1;
    }

    var tabKey = String(tab || '1');
    var tabItem = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab="' + tabKey + '"]')
        .first();

    if (tabItem.length) {
        var tabText = tabItem.text().trim();
        var match = tabText.match(/(\d+)/);
        if (match && match[1]) {
            var parsed = parseInt(match[1], 10);
            if (!isNaN(parsed) && parsed > 0) {
                return parsed;
            }
        }
    }

    if (tabKey === '2') {
        return 3;
    }
    if (tabKey === '3') {
        return 6;
    }
    return 1;
}

function getAmpmBundleFrequencyValue(wrapper, fallbackTab) {
    if (!wrapper || !wrapper.length) {
        return 1;
    }

    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (select.length && select[0] && select[0].options && select[0].options.length) {
        var selectedIndex = select[0].selectedIndex >= 0 ? select[0].selectedIndex : 0;
        var optionNode = select[0].options[selectedIndex] || null;
        if (optionNode) {
            var optionTab = jQuery(optionNode).attr('data-tab');
            if (optionTab) {
                return getAtcSubFrequencyValue(wrapper, optionTab);
            }
        }
    }

    return getAtcSubFrequencyValue(wrapper, fallbackTab || '1');
}

function renderAtcSubPackFrequencyCopy(template, packs, frequency) {
    if (template === undefined || template === null) {
        return '';
    }

    var source = String(template);
    if (!source) {
        return '';
    }

    if (/\{packs\}|\{frequency\}|\{month\}|\{month_display\}|\{packs_display\}|\{pack_display\}|\{bundle\}|\{bundle_display\}|\{box\}|\{box_display\}|\{box display\}/i.test(source)) {
        var packsCount = Number(packs) || 1;
        var frequencyCount = Number(frequency) || 1;
        var monthDisplay = frequencyCount === 1 ? 'Month' : String(frequencyCount) + ' Months';
        var packsDisplay = String(packsCount) + ' Pack' + (packsCount === 1 ? '' : 's');
        var bundleDisplay = String(frequencyCount) + ' Bundle' + (frequencyCount === 1 ? '' : 's');
        var boxDisplay = String(frequencyCount) + ' Box' + (frequencyCount === 1 ? '' : 'es');
        return source
            .replace(/\{packs\}/gi, String(packsCount))
            .replace(/\{frequency\}/gi, String(frequencyCount))
            .replace(/\{month\}/gi, String(frequencyCount))
            .replace(/\{month_display\}/gi, monthDisplay)
            .replace(/\{packs_display\}/gi, packsDisplay)
            .replace(/\{pack_display\}/gi, packsDisplay)
            .replace(/\{bundle\}/gi, String(frequencyCount))
            .replace(/\{bundle_display\}/gi, bundleDisplay)
            .replace(/\{box\}/gi, String(frequencyCount))
            .replace(/\{box_display\}/gi, boxDisplay)
            .replace(/\{box display\}/gi, boxDisplay);
    }

    var compact = source.replace(/\s+/g, ' ').trim();
    if (/^\d+\s+pack(?:s)?\s+every\s+(?:\d+\s+)?month(?:s)?$/i.test(compact)) {
        var fallbackPacks = Number(packs) || 1;
        var fallbackFrequency = Number(frequency) || 1;
        var fallbackMonthDisplay = fallbackFrequency === 1 ? 'Month' : String(fallbackFrequency) + ' Months';
        return (
            String(fallbackPacks) +
            ' Pack' +
            (fallbackPacks === 1 ? '' : 's') +
            ' Every ' +
            fallbackMonthDisplay
        );
    }

    return source;
}

function isAtcSubV9PlainQuantity(wrapper) {
    return !!(
        wrapper &&
        wrapper.length &&
        wrapper.attr('data-v9-plain-quantity') === 'true' &&
        String(wrapper.attr('data-selected-purchase-tab') || '1') === '2'
    );
}

function applyAtcSubPackFrequencyCopy(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    var wrappers = root.hasClass('custom_boc_subscripe_full') ? root : root.find('.custom_boc_subscripe_full');

    wrappers.each(function () {
        var wrapper = jQuery(this);
        wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member_content[data_tab]').each(function () {
            var content = jQuery(this);
            var tab = content.attr('data_tab') || '1';
            var frequency = getAtcSubFrequencyValue(wrapper, tab);
            var packs = frequency;

            content.find('.js-atc-pack-frequency-copy').each(function () {
                var node = jQuery(this);
                var template = node.attr('data-pack-frequency-template');
                if (typeof template !== 'string' || !template.length) {
                    template = node.text().trim();
                    node.attr('data-pack-frequency-template', template);
                }

                var resolved = renderAtcSubPackFrequencyCopy(template, packs, frequency);
                if (node.text() !== resolved) {
                    node.text(resolved);
                }
            });
        });

        wrapper.find('.custom_widget_subscription_content[data_tab="2"] .subscription_heading_member_content[data_tab]').each(function () {
            var content = jQuery(this);
            var tab = content.attr('data_tab') || '1';
            var frequency = getAtcSubFrequencyValue(wrapper, tab);
            var packs = frequency;

            content.find('.js-atc-pack-frequency-copy').each(function () {
                var node = jQuery(this);
                var template = node.attr('data-pack-frequency-template');
                if (typeof template !== 'string' || !template.length) {
                    template = node.text().trim();
                    node.attr('data-pack-frequency-template', template);
                }

                var resolved = renderAtcSubPackFrequencyCopy(template, packs, frequency);
                if (node.text() !== resolved) {
                    node.text(resolved);
                }
            });
        });

        var activeDurationTab = getAtcSubV2ActiveDurationTab(wrapper);
        var ampmFrequency = getAmpmBundleFrequencyValue(wrapper, activeDurationTab);
        var ampmPacks = ampmFrequency;
        wrapper.find('.custom_widget_subscription_content[data_tab="1"] .js-v2-ampm-benefits .js-atc-pack-frequency-copy, .custom_widget_subscription_bundle .subscription_heading_member_content--ampm-bundle .js-atc-pack-frequency-copy').each(function () {
            var node = jQuery(this);
            var template = node.attr('data-pack-frequency-template');
            if (typeof template !== 'string' || !template.length) {
                template = node.text().trim();
                node.attr('data-pack-frequency-template', template);
            }

            var resolved = renderAtcSubPackFrequencyCopy(template, ampmPacks, ampmFrequency);
            if (node.text() !== resolved) {
                node.text(resolved);
            }
        });
    });
}

function getStickyAtcV2Target(wrapper) {
    if (!wrapper || !wrapper.length) {
        return jQuery();
    }

    var sectionRoot = wrapper.closest('.section[id]');
    if (!sectionRoot.length) {
        return jQuery();
    }

    return jQuery('#productStickyInfo-' + sectionRoot.attr('id') + '.product__sticky-info--compact-v2');
}

function getStickyAtcV2Fallback(sticky, key) {
    if (!sticky || !sticky.length) {
        return '';
    }

    var card = sticky.find('.js-sticky-atc-v2-card').first();
    if (!card.length) {
        return '';
    }

    var value = card.attr('data-' + key);
    return typeof value === 'string' ? jQuery.trim(value) : '';
}

function syncAtcSubV2ButtonTotal(wrapper) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('custom_boc_subscripe_full--price-per-month')) {
        return;
    }

    var buttonText = wrapper.find('.custom_product_add_to_carts_main .js-product-form-submit-btn-text[data-base-label]').first();
    if (!buttonText.length) {
        return;
    }

    var baseLabel = buttonText.attr('data-base-label') || 'Add to Cart';
    var selectedTab = getSelectedPurchaseTab(wrapper, wrapper);
    var totalPrice = '';

    if (selectedTab === '3' || wrapper.hasClass('is-v2-ampm-active')) {
        totalPrice = wrapper.find('.js-ampm-bundle-interval option:selected').first().attr('data-total-price-money') || '';
    } else if (selectedTab === '2') {
        // The one-time option is pinned to the first variant, so read its own price --
        // but only while the form still holds that variant. Clicking a supply length
        // arms the subscription without moving the selection off one-time, and the
        // label must not price something the button is not going to add.
        var oneTimeHeading = wrapper.find('.js-one-time-card .custom_widget_subscription_heading_item[data_tab="2"]').first();
        var formVariantId = wrapper.find('.custom_product_add_to_carts_main form [name="id"]').first().val();
        if (oneTimeHeading.length && formVariantId && String(formVariantId) === String(oneTimeHeading.attr('variant_id'))) {
            totalPrice = oneTimeHeading.attr('data-total-price-money') || '';
        } else {
            totalPrice = wrapper.find('.single_prices_main .single_price_item.active').first().attr('data-total-price-money') || '';
        }
    } else {
        totalPrice = wrapper.find('.subscription_prices_main .subscription_prices_item.active').first().attr('data-total-price-money') || '';
    }

    buttonText.text(totalPrice ? baseLabel + ' | ' + totalPrice : baseLabel);
}

function syncStickyAtcV2Card(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    var wrappers = root.hasClass('custom_boc_subscripe_full') ? root : root.find('.custom_boc_subscripe_full');

    wrappers.each(function () {
        var wrapper = jQuery(this);
        syncAtcSubV2ButtonTotal(wrapper);
        var sticky = getStickyAtcV2Target(wrapper);
        if (!sticky.length) {
            return;
        }

        var activeChoice = wrapper.find('.js-v2-bundle-choice.is-active').first();
        var choice = activeChoice.attr('data-choice') || (wrapper.hasClass('is-v2-ampm-active') ? 'ampm' : 'rise');
        var activeHeadingTab = getSelectedPurchaseTab(wrapper, wrapper);
        var activeDuration = wrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
            .first();
        var durationText = activeDuration.length ? jQuery.trim(activeDuration.text()) : '';
        var title = activeChoice.find('.atc-sub-v2__bundle-title').first().text();
        var subtitle = '';

        title = jQuery.trim(title);
        if (!title) {
            title = choice === 'ampm'
                ? getStickyAtcV2Fallback(sticky, 'ampm-title')
                : getStickyAtcV2Fallback(sticky, 'rise-title');
        }

        if (activeHeadingTab === '1' || activeHeadingTab === '3') {
            subtitle = 'Subscribe';
            if (durationText) {
                subtitle += ' | ' + durationText;
            }
        } else if (activeHeadingTab === '2') {
            subtitle = 'One-time purchase';
        }

        if (!subtitle) {
            subtitle = choice === 'ampm'
                ? getStickyAtcV2Fallback(sticky, 'ampm-subtitle')
                : getStickyAtcV2Fallback(sticky, 'rise-subtitle');
        }

        var titleNode = sticky.find('.js-sticky-atc-v2-title').first();
        var subtitleNode = sticky.find('.js-sticky-atc-v2-subtitle').first();
        if (titleNode.length) {
            titleNode.text(title || getStickyAtcV2Fallback(sticky, 'default-title'));
        }
        if (subtitleNode.length) {
            subtitleNode.text(subtitle || getStickyAtcV2Fallback(sticky, 'default-subtitle'));
        }

        var singleImage = sticky.find('.js-sticky-atc-v2-image-single').first();
        var pairImages = sticky.find('.js-sticky-atc-v2-image-pair').first();
        if (choice === 'ampm') {
            var sourceImages = activeChoice.find('.atc-sub-v2__bundle-image-item');
            var leftSrc = sourceImages.eq(0).attr('src');
            var rightSrc = sourceImages.eq(1).attr('src');
            var leftImage = sticky.find('.js-sticky-atc-v2-image-left').first();
            var rightImage = sticky.find('.js-sticky-atc-v2-image-right').first();

            if (leftImage.length && leftSrc) {
                leftImage.attr('src', leftSrc);
                leftImage.attr('alt', title || getStickyAtcV2Fallback(sticky, 'ampm-title'));
            }
            if (rightImage.length && rightSrc) {
                rightImage.attr('src', rightSrc);
                rightImage.attr('alt', title || getStickyAtcV2Fallback(sticky, 'ampm-title'));
            }

            if (singleImage.length) {
                singleImage.attr('hidden', 'hidden');
            }
            if (pairImages.length) {
                pairImages.removeAttr('hidden');
            }
        } else {
            var riseSrc = activeChoice.find('.atc-sub-v2__bundle-image-item').first().attr('src');
            if (singleImage.length) {
                if (riseSrc) {
                    singleImage.attr('src', riseSrc);
                }
                singleImage.attr('alt', title || getStickyAtcV2Fallback(sticky, 'rise-title'));
                singleImage.removeAttr('hidden');
            }
            if (pairImages.length) {
                pairImages.attr('hidden', 'hidden');
            }
        }
    });

    syncAmpmMobileStickyCartPrice(root);
}

function normalizeAmpmMobileStickyPriceText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
}

function getAmpmMobileStickyCartWrapper(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    var wrappers = root.hasClass('custom_boc_subscripe_full') ? root : root.find('.custom_boc_subscripe_full');

    if (!wrappers.length && typeof root.closest === 'function') {
        wrappers = root.closest('.custom_boc_subscripe_full');
    }
    if (!wrappers.length) {
        wrappers = jQuery('.custom_boc_subscripe_full');
    }

    var visibleWrapper = wrappers.filter(function () {
        return jQuery(this).is(':visible');
    }).first();

    return visibleWrapper.length ? visibleWrapper : wrappers.first();
}

function getAmpmMobileStickyPriceFromNode(node) {
    if (!node || !node.length) {
        return '';
    }

    return normalizeAmpmMobileStickyPriceText(node.first().text());
}

function getAmpmMobileStickySelectedPrice(wrapper) {
    if (!wrapper || !wrapper.length) {
        return '';
    }

    var selectedTab = getSelectedPurchaseTab(wrapper, wrapper);
    var isAmpmBundleSelected = selectedTab === '3' || (
        wrapper.hasClass('is-v2-ampm-active') &&
        wrapper.find('.js-ampm-bundle-card.is-active').length
    );
    var price = '';

    if (isAmpmBundleSelected) {
        price = getAmpmMobileStickyPriceFromNode(
            wrapper.find('.js-ampm-bundle-card.is-active .js-ampm-bundle-current-price').first()
        ) || getAmpmMobileStickyPriceFromNode(wrapper.find('.js-ampm-bundle-current-price').first());
    }

    if (!price && selectedTab === '2') {
        price = getAmpmMobileStickyPriceFromNode(
            wrapper.find('.single_prices_main .single_price_item.active .product_price_custom').first()
        ) || getAmpmMobileStickyPriceFromNode(
            wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price .product_price_custom').first()
        ) || getAmpmMobileStickyPriceFromNode(
            wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price').first()
        );
    }

    if (!price && selectedTab === '1') {
        price = getAmpmMobileStickyPriceFromNode(
            wrapper.find('.subscription_prices_item.active .product_price_custom').first()
        ) || getAmpmMobileStickyPriceFromNode(
            wrapper.find('.price_subscription_trigger.subscription_prices_main .subscription_prices_item.active .product_price_custom').first()
        );
    }

    if (!price) {
        price = getAmpmMobileStickyPriceFromNode(
            wrapper.find('.price_subscription_trigger:visible .product_price_custom:visible').first()
        ) || getAmpmMobileStickyPriceFromNode(
            wrapper.find('.custom_widget_subscription_one_time-price:visible').first()
        );
    }

    return price;
}

function syncAmpmMobileStickyCartPrice(scope) {
    var nav = jQuery('.js-mobile-bottom-nav[data-is-ampm-page="true"]').first();
    if (!nav.length) {
        return;
    }

    var priceTarget = nav.find('.js-mobile-bottom-nav-price').first();
    if (!priceTarget.length) {
        return;
    }

    var wrapper = getAmpmMobileStickyCartWrapper(scope);
    var price = getAmpmMobileStickySelectedPrice(wrapper);

    if (price) {
        priceTarget.text(price).removeAttr('hidden');
        nav.addClass('has-price');
    } else {
        priceTarget.text('').attr('hidden', 'hidden');
        nav.removeClass('has-price');
    }
}

window.syncAmpmMobileStickyCartPrice = syncAmpmMobileStickyCartPrice;

function extractAtcSubV2DiscountPercent(text) {
    if (!text) {
        return '';
    }
    var match = String(text).match(/(\d+(?:[.,]\d+)?)\s*%/);
    if (!match || !match[1]) {
        return '';
    }
    return match[1].replace(',', '.') + '%';
}

function normalizeDiscountPercent(value) {
    if (value === undefined || value === null) {
        return '';
    }
    var text = String(value).trim();
    if (!text) {
        return '';
    }
    var match = text.match(/(-?\d+(?:[.,]\d+)?)/);
    if (!match || !match[1]) {
        return '';
    }
    return match[1].replace(',', '.') + '%';
}

function templateHasDiscountToken(template) {
    return typeof template === 'string' && /\{discount\}/i.test(template);
}

function applyDiscountTemplateValue(template, discountPercent) {
    if (typeof template !== 'string') {
        return '';
    }
    return template
        .replace(/\{discount\}%/gi, discountPercent || '')
        .replace(/\{discount\}/gi, discountPercent || '');
}

function applyDiscountTemplates(wrapper, discountPercent, context) {
    if (!wrapper || !wrapper.length) {
        return;
    }
    context = context || {};
    var selectedPurchaseTab = getSelectedPurchaseTab(wrapper, wrapper);
    wrapper.find('[data-discount-template], [data-discount-template-html]').each(function () {
        var node = jQuery(this);
        var discountForNode = discountPercent;
        var source = (node.attr('data-discount-source') || '').toLowerCase();
        var forceTemplateValue = false;
        var htmlTemplateOverride = '';
        var textTemplateOverride = '';
        if (source === 'ampm') {
            if (selectedPurchaseTab === '2') {
                htmlTemplateOverride = node.attr('data-one-time-template-html') || '';
                textTemplateOverride = node.attr('data-one-time-template') || '';
                forceTemplateValue = !!(htmlTemplateOverride || textTemplateOverride);
            }
            if (context.ampmDiscount) {
                discountForNode = context.ampmDiscount;
            } else if (context.activeDiscount) {
                discountForNode = context.activeDiscount;
            } else {
                return;
            }
            node.removeAttr('data-discount-ampm-frozen');
        } else if (source === 'active' && context.activeDiscount) {
            discountForNode = context.activeDiscount;
        }

        var htmlTemplate = htmlTemplateOverride || node.attr('data-discount-template-html');
        if (typeof htmlTemplate === 'string' && htmlTemplate.length) {
            if (!forceTemplateValue && !templateHasDiscountToken(htmlTemplate)) {
                return;
            }
            node.html(applyDiscountTemplateValue(htmlTemplate, discountForNode));
            return;
        }
        var textTemplate = textTemplateOverride || node.attr('data-discount-template');
        if (typeof textTemplate !== 'string' || (!forceTemplateValue && !templateHasDiscountToken(textTemplate))) {
            return;
        }
        node.text(applyDiscountTemplateValue(textTemplate, discountForNode));
    });
}

function syncManualTitleDiscounts(scope) {
    var sectionRoots = {};
    var roots = [];

    function pushSectionRoot(node) {
        if (!node) {
            return;
        }
        var root = jQuery(node).closest('[id^="shopify-section-"], .shopify-section').get(0) || null;
        if (!root) {
            root = document;
        }
        var key = root === document ? 'document' : (root.id || jQuery(root).attr('class') || ('root-' + roots.length));
        if (!sectionRoots[key]) {
            sectionRoots[key] = true;
            roots.push(root);
        }
    }

    if (scope && scope.jquery) {
        if (scope.length) {
            scope.each(function () {
                pushSectionRoot(this);
            });
            scope.find('.product__manual-title-subtext, [data-manual-title-discount-template-html], .custom_boc_subscripe_full').each(function () {
                pushSectionRoot(this);
            });
        }
    } else {
        roots.push(document);
    }

    if (!roots.length) {
        roots.push(document);
    }

    jQuery(roots).each(function () {
        var root = this === document ? jQuery(document) : jQuery(this);
        var nodes = root.find('[data-manual-title-discount-template-html], .product__manual-title-subtext');
        if (!nodes.length) {
            return;
        }

        var wrapper = root.find('.custom_boc_subscripe_full--v8').first();
        if (!wrapper.length) {
            wrapper = root.find('.custom_boc_subscripe_full').first();
        }
        if (!wrapper.length) {
            return;
        }

        var activeDiscount = getAtcSubV2ActiveDiscount(wrapper);
        var ampmDiscount = getAmpmBundleDiscount(wrapper) || activeDiscount;

        nodes.each(function () {
            var node = jQuery(this);
            var template = node.attr('data-manual-title-discount-template-html') || '';
            var source = (node.attr('data-discount-source') || '').toLowerCase();
            var discountForNode = source === 'ampm' ? ampmDiscount : activeDiscount;

            if (!template) {
                var currentHtml = node.html();
                if (typeof currentHtml === 'string' && templateHasDiscountToken(currentHtml)) {
                    template = currentHtml;
                    node.attr('data-manual-title-discount-template-html', currentHtml);
                    if (!source) {
                        node.attr('data-discount-source', 'ampm');
                        source = 'ampm';
                        discountForNode = ampmDiscount;
                    }
                } else if (typeof currentHtml === 'string' && /save/i.test(currentHtml) && /%/.test(currentHtml)) {
                    var inferredTemplate = currentHtml.replace(/-?\d+(?:[.,]\d+)?\s*%/i, '{discount}');
                    if (templateHasDiscountToken(inferredTemplate)) {
                        template = inferredTemplate;
                        node.attr('data-manual-title-discount-template-html', inferredTemplate);
                        if (!source) {
                            node.attr('data-discount-source', 'ampm');
                            source = 'ampm';
                            discountForNode = ampmDiscount;
                        }
                    }
                }
            }

            if (!template || !templateHasDiscountToken(template)) {
                return;
            }

            node.html(applyDiscountTemplateValue(template, discountForNode));
        });
    });
}

function getAmpmBundleDiscount(wrapper) {
    if (!wrapper || !wrapper.length) {
        return '';
    }
    var selectedPurchaseTab = getSelectedPurchaseTab(wrapper, wrapper);
    var activeTab = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
        .first()
        .attr('data_tab');
    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (!select.length || !select[0].options || !select[0].options.length) {
        return '';
    }

    var optionNode = null;
    if (activeTab) {
        optionNode = select.find('option[data-tab="' + activeTab + '"]').get(0) || null;
    }

    if (!optionNode) {
        var selectedIndex = select[0].selectedIndex >= 0 ? select[0].selectedIndex : 0;
        optionNode = select[0].options[selectedIndex] || select[0].options[0] || null;
    }
    if (!optionNode) return '';

    if (selectedPurchaseTab === '2') {
        return normalizeDiscountPercent(jQuery(optionNode).attr('data-total-one-time-discount-pct'));
    }

    return normalizeDiscountPercent(jQuery(optionNode).attr('data-total-discount-pct'));
}

function getAtcSubV2ActiveDiscount(wrapper) {
    if (!wrapper || !wrapper.length) {
        return '';
    }

    var discountPercent = '';
    if (wrapper.hasClass('is-v2-ampm-active')) {
        discountPercent = getAmpmBundleDiscount(wrapper);
    }

    if (!discountPercent) {
        var activeSaveText = wrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member')
            .not('.months')
            .first()
            .find('.subscription_heading_member_item.active span')
            .first()
            .text()
            .trim();
        discountPercent = extractAtcSubV2DiscountPercent(activeSaveText);
    }

    return discountPercent;
}

function updateAtcSubV2SubscribeLabel(wrapper) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('js-atc-sub-v2')) {
        return;
    }

    var subscribeLabel = wrapper.find('.js-v2-subscribe-label').first();
    var discountPercent = getAtcSubV2ActiveDiscount(wrapper);
    var ampmDiscount = getAmpmBundleDiscount(wrapper);
    var inlineSaveEnabled = false;

    if (subscribeLabel.length) {
        inlineSaveEnabled = subscribeLabel.attr('data-inline-save') === 'true';
        var baseLabel = subscribeLabel.attr('data-base-label') || subscribeLabel.text().trim();
        if (!subscribeLabel.attr('data-base-label')) {
            subscribeLabel.attr('data-base-label', baseLabel);
        }

        var nextLabel = baseLabel;
        if (templateHasDiscountToken(baseLabel)) {
            nextLabel = applyDiscountTemplateValue(baseLabel, discountPercent);
        } else if (inlineSaveEnabled && discountPercent) {
            nextLabel = (baseLabel + ' ' + discountPercent).trim();
        }

        subscribeLabel.text(nextLabel);
    }

    wrapper.toggleClass('is-v2-inline-save-enabled', inlineSaveEnabled);
    wrapper.find('.price_subscription_trigger.subscription_prices_main .product_compareprice_custom_save').toggle(!inlineSaveEnabled);
    applyDiscountTemplates(wrapper, discountPercent, {
        activeDiscount: discountPercent,
        ampmDiscount: ampmDiscount
    });
    syncManualTitleDiscounts(wrapper);
}

function syncAtcSubV4State(wrapper) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('js-atc-sub-v4')) {
        return;
    }

    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (!select.length || !select[0].options || select[0].selectedIndex < 0) {
        return;
    }

    var option = jQuery(select[0].options[select[0].selectedIndex]);
    var totalPriceMoney = option.attr('data-total-price-money') || '';
    var totalCompareMoney = option.attr('data-total-compare-money') || '';
    var discountPct = option.attr('data-total-discount-pct') || '';
    var discountPercent = normalizeDiscountPercent(discountPct);
    var savePrefix = wrapper.attr('data-v4-save-prefix') || 'Save';

    var currentPrice = wrapper.find('.js-ampm-bundle-current-price').first();
    if (currentPrice.length && totalPriceMoney) {
        currentPrice.text(totalPriceMoney);
    }

    var subscribeCurrentPrice = wrapper.find('.js-atc-v4-subscribe-current-price').first();
    if (subscribeCurrentPrice.length && totalPriceMoney) {
        subscribeCurrentPrice.text(totalPriceMoney);
    }

    var comparePrice = wrapper.find('.js-ampm-bundle-compare-price').first();
    if (comparePrice.length) {
        if (totalCompareMoney && totalCompareMoney !== totalPriceMoney) {
            comparePrice.text(totalCompareMoney).show();
        } else {
            comparePrice.text('').hide();
        }
    }

    var subscribeComparePrice = wrapper.find('.js-atc-v4-subscribe-compare-price').first();
    if (subscribeComparePrice.length) {
        if (totalCompareMoney && totalCompareMoney !== totalPriceMoney) {
            subscribeComparePrice.text(totalCompareMoney).show();
        } else {
            subscribeComparePrice.text('').hide();
        }
    }

    var savePill = wrapper.find('.js-atc-v4-save-pill').first();
    if (savePill.length) {
        var savePillText = savePill.find('.js-atc-v4-save-pill-text').first();
        if (discountPercent) {
            var nextLabel = '';
            if (templateHasDiscountToken(savePrefix)) {
                nextLabel = applyDiscountTemplateValue(savePrefix, discountPercent);
            } else {
                nextLabel = (savePrefix ? savePrefix + ' ' : '') + discountPercent;
            }
            if (savePillText.length) {
                savePillText.text(nextLabel);
            } else {
                savePill.text(nextLabel);
            }
            savePill.show();
        } else {
            if (savePillText.length) {
                savePillText.text('');
            } else {
                savePill.text('');
            }
            savePill.hide();
        }
    }

    var buttonPrice = wrapper.find('.js-atc-v4-button-price').first();
    if (buttonPrice.length && totalPriceMoney) {
        buttonPrice.text(totalPriceMoney);
    }

    applyDiscountTemplates(wrapper, discountPercent, {
        activeDiscount: discountPercent,
        ampmDiscount: discountPercent
    });
    syncManualTitleDiscounts(wrapper);
}

function cacheAtcSubV2BaseState(wrapper) {
    if (!wrapper || !wrapper.length || wrapper.attr('data-v2-base-cached') === 'true') {
        return;
    }

    wrapper.find('.price_subscription_trigger.subscription_prices_main .subscription_prices_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
            var saveElm = item.find('.product_compareprice_custom_save').first();
            item.attr('data-v2-base-price', priceElm.text().trim());
            item.attr('data-v2-base-compare', compareElm.text().trim());
            item.attr('data-v2-base-save', saveElm.text().trim());
    });

    wrapper.find('.price_subscription_trigger.single_prices_main .single_price_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
        item.attr('data-v2-base-price', priceElm.text().trim());
        item.attr('data-v2-base-compare', compareElm.text().trim());
    });

    var oneTimeCardPrice = wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price').first();
    if (oneTimeCardPrice.length && !oneTimeCardPrice.attr('data-v2-base-html')) {
        oneTimeCardPrice.attr('data-v2-base-html', oneTimeCardPrice.html());
    }

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        item.attr('data-v2-base-variant-id', item.attr('variant_id') || '');
        item.attr('data-v2-base-selling-plan', item.attr('selling_plan') || '');
        item.attr('data-v2-base-per-day', item.attr('data-per-day') || '');
    });

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member').not('.months').first().find('.subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        item.attr('data-v2-base-save-label', item.find('span').text().trim());
    });

    wrapper.attr('data-v2-base-cached', 'true');
}

function updateAtcSubV2OneTimeBundlePrice(wrapper, priceMoney, compareMoney) {
    if (!wrapper || !wrapper.length) {
        return;
    }

    wrapper.find('.price_subscription_trigger.single_prices_main .single_price_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();

        if (priceMoney) {
            priceElm.text(priceMoney);
        }
        if (compareMoney && compareMoney !== priceMoney) {
            compareElm.text(compareMoney).show();
        } else {
            compareElm.text('').hide();
        }
    });

    var oneTimeCardPrice = wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price').first();
    if (!oneTimeCardPrice.length) {
        return;
    }

    var nextHtml = '';
    if (compareMoney && compareMoney !== priceMoney) {
        nextHtml += '<span class="product_compareprice_custom money">' + compareMoney + '</span>';
    }
    nextHtml += '<span class="product_price_custom money">' + priceMoney + '</span>';
    oneTimeCardPrice.html(nextHtml);
}

function getAmpmBundleSelectedPriceData(wrapper) {
    if (!wrapper || !wrapper.length) {
        return null;
    }

    var select = wrapper.find('.js-ampm-bundle-interval').first();
    if (!select.length || !select[0] || !select[0].options || !select[0].options.length) {
        return null;
    }

    var selectedIndex = select[0].selectedIndex >= 0 ? select[0].selectedIndex : 0;
    var option = jQuery(select[0].options[selectedIndex] || select[0].options[0]);
    if (!option.length) {
        return null;
    }

    return {
        priceMoney: option.attr('data-total-one-time-price-money') || '',
        compareMoney: option.attr('data-total-one-time-compare-money') || ''
    };
}

function syncAtcSubV9OneTimeState(wrapper) {
    var root = wrapper && wrapper.length ? wrapper : jQuery(document);
    var wrappers = root.hasClass('custom_boc_subscripe_full') ? root : root.find('.custom_boc_subscripe_full[data-v9-plain-quantity="true"]');

    wrappers.each(function () {
        var currentWrapper = jQuery(this);
        if (currentWrapper.attr('data-v9-plain-quantity') !== 'true') {
            return;
        }

        var selectedPurchaseTab = getSelectedPurchaseTab(currentWrapper, currentWrapper);
        var isOneTimeSelected = selectedPurchaseTab === '2';
        var otpContent = currentWrapper.find('.custom_widget_subscription_content--v9-one-time[data_tab="2"]').first();
        var activeDurationTab = getAtcSubV2ActiveDurationTab(currentWrapper) || '1';
        var isPlainQuantityOtp = isAtcSubV9PlainQuantity(currentWrapper);
        var isAmpmSelected = currentWrapper.hasClass('is-v2-ampm-active') && !isPlainQuantityOtp;
        var subscribeDetails = currentWrapper.find('.custom_widget_subscription_content[data_tab="1"]').first();
        var monthItems = subscribeDetails.find('.subscription_heading_member.months .subscription_heading_member_item[data_tab]');
        var saveItems = subscribeDetails.find('.subscription_heading_member').not('.months').first().find('.subscription_heading_member_item[data_tab]');
        var benefitRows = subscribeDetails.children('.subscription_heading_member_content[data_tab]').not('.js-v9-otp-benefits');
        var hiddenOtpRows = subscribeDetails.children('.js-v9-otp-benefits[data_tab]');
        var bundleBenefits = subscribeDetails.children('.js-v2-ampm-benefits').first();
        var hiddenOtpBundleBenefits = currentWrapper.find('.js-v9-otp-ampm-benefits').first();

        currentWrapper.toggleClass('is-one-time-selected', isOneTimeSelected);
        currentWrapper.find('.custom_widget_subscription').toggle(!isOneTimeSelected);
        if (subscribeDetails.length) {
            subscribeDetails.toggle(!isOneTimeSelected);
        }
        hiddenOtpRows.hide();
        hiddenOtpBundleBenefits.hide();
        otpContent.hide();
        currentWrapper.find('[data-atc-sub-v9-subscription-note], .atc-sub-v9__subscription-note').prop('hidden', isOneTimeSelected);
        currentWrapper.find('.custom_widget_subscription_classpass, .custom_widget_subscription_bundle-classpass').toggle(!isOneTimeSelected);

        if (!otpContent.length) {
            return;
        }

        monthItems.each(function () {
            var item = jQuery(this);
            if (!item.attr('data-v9-original-label')) {
                item.attr('data-v9-original-label', jQuery.trim(item.text()));
            }
            if (!item.attr('data-v9-original-per-day')) {
                item.attr('data-v9-original-per-day', item.attr('data-per-day') || '');
            }
        });

        saveItems.each(function () {
            var item = jQuery(this);
            var labelNode = item.find('span').first();
            if (!item.attr('data-v9-original-label')) {
                item.attr('data-v9-original-label', jQuery.trim(labelNode.text()));
            }
        });

        benefitRows.each(function () {
            var row = jQuery(this);
            if (typeof row.attr('data-v9-original-html') !== 'string') {
                row.attr('data-v9-original-html', row.html());
            }
        });

        if (bundleBenefits.length && typeof bundleBenefits.attr('data-v9-original-html') !== 'string') {
            bundleBenefits.attr('data-v9-original-html', bundleBenefits.html());
        }

        otpContent.find('.subscription_heading_member_item--v9-otp').each(function () {
            var item = jQuery(this);
            var tab = String(item.attr('data_tab') || '');
            var label = isAmpmSelected
                ? (item.attr('data-v9-otp-bundle-label') || item.attr('data-v9-otp-single-label') || '')
                : (item.attr('data-v9-otp-single-label') || '');
            var perDay = item.attr('data-v9-otp-single-per-day') || '';

            if (isAmpmSelected) {
                var option = currentWrapper.find('.js-ampm-bundle-interval option[data-tab="' + tab + '"]').first();
                if (option.length) {
                    perDay = option.attr('data-total-one-time-per-day') || perDay;
                }
            }

            item.find('.js-v9-otp-tier-label').text(label);
            item.find('.js-v9-otp-tier-per-day').text(perDay);
            item.toggleClass('active', tab === String(activeDurationTab));

            var subscribeItem = monthItems.filter('[data_tab="' + tab + '"]').first();
            if (subscribeItem.length && isOneTimeSelected) {
                subscribeItem.text(label);
                subscribeItem.attr('data-per-day', perDay);
                subscribeItem.addClass('active');
            }
        });

        otpContent.find('.js-v9-otp-save-pill').each(function () {
            var pill = jQuery(this);
            var tab = String(pill.attr('data_tab') || '');
            var saveText = '';

            if (isAmpmSelected) {
                var option = currentWrapper.find('.js-ampm-bundle-interval option[data-tab="' + tab + '"]').first();
                if (option.length) {
                    var bundleDiscount = normalizeDiscountPercent(option.attr('data-total-one-time-discount-pct') || '');
                    if (bundleDiscount === '0%') {
                        bundleDiscount = '';
                    }
                    saveText = bundleDiscount ? ('Save ' + bundleDiscount) : '';
                }
            } else {
                var durationItem = otpContent.find('.subscription_heading_member_item--v9-otp[data_tab="' + tab + '"]').first();
                var singleDiscount = normalizeDiscountPercent(durationItem.attr('data-v9-one-time-discount') || '');
                if (singleDiscount === '0%') {
                    singleDiscount = '';
                }
                saveText = singleDiscount ? ('Save ' + singleDiscount) : '';
            }

            pill.find('span').text(saveText);
            pill.toggleClass('is-active', tab === String(activeDurationTab));
            pill.toggleClass('is-hidden', !saveText);

            var subscribeSaveItem = saveItems.filter('[data_tab="' + tab + '"]').first();
            if (subscribeSaveItem.length && isOneTimeSelected) {
                var subscribeSaveLabel = subscribeSaveItem.find('span').first();
                subscribeSaveLabel.text(saveText);
                subscribeSaveItem.toggleClass('active', tab === String(activeDurationTab));
                subscribeSaveItem.css('visibility', saveText ? '' : 'hidden');
            }
        });

        var bundleDiscountPercent = getAmpmBundleDiscount(currentWrapper);
        if (bundleDiscountPercent) {
            applyDiscountTemplates(currentWrapper, bundleDiscountPercent, {
                activeDiscount: bundleDiscountPercent,
                ampmDiscount: bundleDiscountPercent
            });
        }

        otpContent.find('.subscription_heading_member_content--v9-otp-row').hide()
            .filter('[data_tab="' + activeDurationTab + '"]').show();

        otpContent.find('.js-v9-otp-single-copy').toggle(!isAmpmSelected);
        otpContent.find('.js-v9-otp-bundle-copy').toggle(isAmpmSelected);

        if (isOneTimeSelected) {
            monthItems.removeClass('active')
                .filter('[data_tab="' + activeDurationTab + '"]').addClass('active');

            benefitRows.hide();
            bundleBenefits.hide();

            if (isAmpmSelected && bundleBenefits.length && hiddenOtpBundleBenefits.length) {
                bundleBenefits.html(hiddenOtpBundleBenefits.html()).show();
            } else {
                var activeBenefitRow = benefitRows.filter('[data_tab="' + activeDurationTab + '"]').first();
                var sourceBenefitRow = hiddenOtpRows.filter('[data_tab="' + activeDurationTab + '"]').first();
                if (activeBenefitRow.length && sourceBenefitRow.length) {
                    activeBenefitRow.html(sourceBenefitRow.html()).show();
                }
            }

            applyAtcSubPackFrequencyCopy(currentWrapper);
        } else {
            monthItems.each(function () {
                var item = jQuery(this);
                item.text(item.attr('data-v9-original-label') || '');
                item.attr('data-per-day', item.attr('data-v9-original-per-day') || '');
            });

            saveItems.each(function () {
                var item = jQuery(this);
                item.find('span').first().text(item.attr('data-v9-original-label') || '');
                item.css('visibility', '');
            });

            benefitRows.each(function () {
                var row = jQuery(this);
                var originalHtml = row.attr('data-v9-original-html');
                if (typeof originalHtml === 'string') {
                    row.html(originalHtml);
                }
            });

            if (bundleBenefits.length) {
                var originalBundleHtml = bundleBenefits.attr('data-v9-original-html');
                if (typeof originalBundleHtml === 'string') {
                    bundleBenefits.html(originalBundleHtml);
                }
            }
        }
    });
}

function applyAtcSubV2AmpmState(wrapper) {
    var primaryIntervalSelect = wrapper.find('.js-ampm-bundle-interval').first();
    var options = primaryIntervalSelect.find('option');
    if (!options.length) {
        return;
    }

    options.each(function () {
        var option = jQuery(this);
        var tab = option.attr('data-tab');
        if (!tab) return;

        var priceMoney = option.attr('data-total-price-money') || '';
        var compareMoney = option.attr('data-total-compare-money') || '';
        var discountPct = option.attr('data-total-discount-pct') || '';
        var perDay = option.attr('data-total-per-day') || '';
        var variantId = option.attr('data-main-variant-id') || '';
        var sellingPlanId = option.attr('data-main-selling-plan-id') || '';

        wrapper.find('.price_subscription_trigger.subscription_prices_main .subscription_prices_item[data_tab="' + tab + '"]').each(function () {
            var priceItem = jQuery(this);
            var priceElm = priceItem.find('.product_price_custom').first();
            var compareElm = priceItem.find('.product_compareprice_custom').first();
            var saveElm = priceItem.find('.product_compareprice_custom_save').first();
            if (priceMoney) {
                priceElm.text(priceMoney);
            }
            if (compareMoney && compareMoney !== priceMoney) {
                compareElm.text(compareMoney).show();
            } else {
                compareElm.text('').hide();
            }
            if (discountPct !== '') {
                saveElm.text('Save ' + discountPct + '%');
            }
        });

        var durationItem = wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab="' + tab + '"]');
        if (durationItem.length) {
            durationItem.attr('variant_id', variantId);
            durationItem.attr('selling_plan', sellingPlanId);
            durationItem.attr('data-per-day', perDay);
        }

        var saveLabelItem = wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member').not('.months').first().find('.subscription_heading_member_item[data_tab="' + tab + '"] span');
        if (saveLabelItem.length && discountPct !== '') {
            saveLabelItem.text('Save ' + discountPct + '%');
        }
    });

    var selectedPriceData = getAmpmBundleSelectedPriceData(wrapper);
    if (selectedPriceData) {
        updateAtcSubV2OneTimeBundlePrice(wrapper, selectedPriceData.priceMoney, selectedPriceData.compareMoney);
    }
}

function restoreAtcSubV2BaseState(wrapper) {
    wrapper.find('.price_subscription_trigger.subscription_prices_main .subscription_prices_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
        var saveElm = item.find('.product_compareprice_custom_save').first();
        var basePrice = item.attr('data-v2-base-price') || '';
        var baseCompare = item.attr('data-v2-base-compare') || '';
        var baseSave = item.attr('data-v2-base-save') || '';

        if (basePrice) {
            priceElm.text(basePrice);
        }
        if (baseCompare) {
            compareElm.text(baseCompare).show();
        } else {
            compareElm.text('').hide();
        }
        if (baseSave) {
            saveElm.text(baseSave);
        }
    });

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        item.attr('variant_id', item.attr('data-v2-base-variant-id') || item.attr('variant_id'));
        item.attr('selling_plan', item.attr('data-v2-base-selling-plan') || item.attr('selling_plan'));
        item.attr('data-per-day', item.attr('data-v2-base-per-day') || item.attr('data-per-day'));
    });

    wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member').not('.months').first().find('.subscription_heading_member_item').each(function () {
        var item = jQuery(this);
        var label = item.attr('data-v2-base-save-label');
        if (label) {
            item.find('span').text(label);
        }
    });

    wrapper.find('.price_subscription_trigger.single_prices_main .single_price_item').each(function () {
        var item = jQuery(this);
        var priceElm = item.find('.product_price_custom').first();
        var compareElm = item.find('.product_compareprice_custom').first();
        var basePrice = item.attr('data-v2-base-price') || '';
        var baseCompare = item.attr('data-v2-base-compare') || '';

        if (basePrice) {
            priceElm.text(basePrice);
        }
        if (baseCompare) {
            compareElm.text(baseCompare).show();
        } else {
            compareElm.text('').hide();
        }
    });

    var oneTimeCardPrice = wrapper.find('.js-one-time-card .custom_widget_subscription_one_time-price').first();
    if (oneTimeCardPrice.length) {
        var baseHtml = oneTimeCardPrice.attr('data-v2-base-html');
        if (typeof baseHtml === 'string' && baseHtml.length) {
            oneTimeCardPrice.html(baseHtml);
        }
    }
}

function toggleAtcSubV2TextContent(wrapper, activeTab) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('js-atc-sub-v2')) {
        return;
    }

    if (!activeTab) {
        activeTab = '1';
    }

    var detailsContainer = wrapper.find('.custom_widget_subscription_content[data_tab="1"]');
    if (!detailsContainer.length) {
        return;
    }

    var hasAmpmMode = wrapper.hasClass('is-v2-ampm-active');
    var ampmBenefits = detailsContainer.find('.js-v2-ampm-benefits');

    detailsContainer.find('.subscription_heading_member_content').hide();

    if (hasAmpmMode && ampmBenefits.length) {
        ampmBenefits.show();
        return;
    }

    if (detailsContainer.find('.subscription_heading_member_content[data_tab="' + activeTab + '"]').length) {
        detailsContainer.find('.subscription_heading_member_content[data_tab="' + activeTab + '"]').show();
    }
}

function getAtcSubV2ActiveDurationTab(wrapper) {
    if (!wrapper || !wrapper.length) {
        return '1';
    }

    var activeTab = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
        .first()
        .attr('data_tab');
    if (activeTab) {
        return String(activeTab);
    }

    var firstTab = wrapper
        .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab]')
        .first()
        .attr('data_tab');
    return String(firstTab || '1');
}

function syncAtcSubV2BundleIntervals(wrapper, targetTab, triggerPrimaryChange) {
    if (!wrapper || !wrapper.length) {
        return;
    }

    var tab = String(targetTab || getAtcSubV2ActiveDurationTab(wrapper) || '1');
    var selects = wrapper.find('.js-ampm-bundle-interval');
    if (!selects.length) {
        return;
    }

    var primaryTriggered = false;
    selects.each(function () {
        var select = jQuery(this);
        var option = select.find('option[data-tab="' + tab + '"]').first();
        if (!option.length) {
            return;
        }

        select.val(option.val());
        if (triggerPrimaryChange && !primaryTriggered) {
            primaryTriggered = true;
            select.trigger('change');
        }
    });
}

function toggleAtcSubV3MonthsRow(wrapper, shouldHide) {
    if (!wrapper || !wrapper.length || !wrapper.hasClass('custom_boc_subscripe_full--v3')) {
        return;
    }

    var swatchRows = wrapper.find('.custom_widget_subscription_content[data_tab="1"] > .subscription_heading_member');
    if (!swatchRows.length) {
        return;
    }

    swatchRows.each(function () {
        var row = jQuery(this);
        if (shouldHide) {
            row.attr('hidden', 'hidden');
            if (this.style && typeof this.style.setProperty === 'function') {
                this.style.setProperty('display', 'none', 'important');
            } else {
                row.css('display', 'none');
            }
            return;
        }

        row.removeAttr('hidden');
        if (this.style && typeof this.style.removeProperty === 'function') {
            this.style.removeProperty('display');
        } else {
            row.css('display', '');
        }
    });
}

function setAtcSubV2Mode(wrapper, isAmpm) {
    if (!wrapper || !wrapper.length) {
        return;
    }

    cacheAtcSubV2BaseState(wrapper);
    wrapper.toggleClass('is-v2-ampm-active', !!isAmpm);
    wrapper.find('.js-v2-bundle-choice').removeClass('is-active');
    wrapper.find('.js-v2-bundle-choice[data-choice="' + (isAmpm ? 'ampm' : 'rise') + '"]').addClass('is-active');

    if (isAmpm) {
        applyAtcSubV2AmpmState(wrapper);
        syncAtcSubV2BundleIntervals(wrapper, getAtcSubV2ActiveDurationTab(wrapper), true);
    } else {
        restoreAtcSubV2BaseState(wrapper);
        syncAtcSubV2BundleIntervals(wrapper, getAtcSubV2ActiveDurationTab(wrapper), false);
    }
    toggleAtcSubV3MonthsRow(wrapper, !!isAmpm);

    var subscribeHeading = wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').first();
    if (subscribeHeading.length) {
        subscribeHeading.trigger('click');
    }
    if (isAmpm) {
        wrapper.find('.custom_widget_subscription_bundle .js-ampm-bundle-heading').first().addClass('active');
        syncAmpmBundleCardState(wrapper);
    } else {
        wrapper.find('.custom_widget_subscription_bundle .js-ampm-bundle-heading').first().removeClass('active');
        syncAmpmBundleCardState(wrapper);
    }
    updateAtcSubV2SubscribeLabel(wrapper);
    var activeTab = wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member_item.active[data_tab]').first().attr('data_tab') || '1';
    toggleAtcSubV2TextContent(wrapper, activeTab);
    syncAtcSubV9OneTimeState(wrapper);
    syncStickyAtcV2Card(wrapper);
}

function setAtcSubV5ModeVisual(wrapper, isAmpm) {
    if (!wrapper || !wrapper.length) {
        return;
    }

    cacheAtcSubV2BaseState(wrapper);
    wrapper.toggleClass('is-v2-ampm-active', !!isAmpm);
    wrapper.find('.js-v2-bundle-choice').removeClass('is-active');
    wrapper.find('.js-v2-bundle-choice[data-choice="' + (isAmpm ? 'ampm' : 'rise') + '"]').addClass('is-active');

    if (isAmpm) {
        applyAtcSubV2AmpmState(wrapper);
        syncAtcSubV2BundleIntervals(wrapper, getAtcSubV2ActiveDurationTab(wrapper), true);
    } else {
        restoreAtcSubV2BaseState(wrapper);
        syncAtcSubV2BundleIntervals(wrapper, getAtcSubV2ActiveDurationTab(wrapper), false);
    }

    toggleAtcSubV3MonthsRow(wrapper, !!isAmpm);
    updateAtcSubV2SubscribeLabel(wrapper);
    syncAmpmBundleCardState(wrapper);
    syncAtcSubV9OneTimeState(wrapper);
    applyAtcSubPackFrequencyCopy(wrapper);
    syncStickyAtcV2Card(wrapper);
}

function shouldForceAmpmBundleFromQuery() {
    if (typeof window === 'undefined' || !window.location) {
        return false;
    }

    var params = new URLSearchParams(window.location.search || '');
    var bundle = (params.get('bundle') || '').toLowerCase();
    return bundle === 'ampm' || bundle === 'am-pm' || bundle === 'routine';
}

function initAtcSubV2(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    var forceAmpmFromQuery = shouldForceAmpmBundleFromQuery();
    root.find('.js-atc-sub-v2').each(function () {
        var wrapper = jQuery(this);
        cacheAtcSubV2BaseState(wrapper);
        if (wrapper.hasClass('custom_boc_subscripe_full--v5')) {
            setAtcSubV5ModeVisual(wrapper, true);
            var bundleHeading = wrapper.find('.custom_widget_subscription_bundle .js-ampm-bundle-heading').first();
            if (bundleHeading.length) {
                bundleHeading.trigger('click');
            }
            return;
        }
        if (!wrapper.find('.js-v2-bundle-choice.is-active').length) {
            wrapper.find('.js-v2-bundle-choice[data-choice="rise"]').addClass('is-active');
        }
        if (forceAmpmFromQuery && wrapper.attr('data-hide-bundle-step') !== 'true') {
            wrapper.addClass('is-v2-ampm-active');
            wrapper.attr('data-default-purchase-tab', '3');
            wrapper.attr('data-selected-purchase-tab', '3');
        }
        setAtcSubV2Mode(wrapper, wrapper.hasClass('is-v2-ampm-active'));
    });
}

function initAtcSubV4(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    root.find('.js-atc-sub-v4').each(function () {
        syncAtcSubV4State(jQuery(this));
    });
}

jQuery(document).on('click', 'span.custom_widget_subscription_heading_item', function () {
    var heading = jQuery(this);
    var widgetWrapper = heading.closest('.custom_boc_subscripe_full');
    var subscriptionCard = heading.closest('.custom_widget_subscription');
    var scopedRoot = widgetWrapper.length ? widgetWrapper : subscriptionCard;
    var scopedForm = scopedRoot.find('.custom_product_add_to_carts_main form').first();
    if (!subscriptionCard.length && widgetWrapper.length) {
        subscriptionCard = widgetWrapper.find('.custom_widget_subscription').first();
    }

    var current_tab = heading.attr('data_tab');
    var selling_plan = heading.attr('selling_plan');
    var variant_id = heading.attr('variant_id');
    var isV9PlainQuantity = isAtcSubV9PlainQuantity(widgetWrapper);
    var keepSubscribeOpenOnOneTimeClick = widgetWrapper.attr('data-keep-subscribe-open-on-one-time-click') === 'true';
    var pinSubscribeOpen = keepSubscribeOpenOnOneTimeClick && current_tab === '2';

    if (widgetWrapper.length) {
        widgetWrapper.attr('data-selected-purchase-tab', current_tab);
        widgetWrapper.find('span.custom_widget_subscription_heading_item').removeClass('active is-open is-selected');
    } else if (subscriptionCard.length) {
        subscriptionCard.find('span.custom_widget_subscription_heading_item').removeClass('active is-open is-selected');
    } else {
        jQuery('span.custom_widget_subscription_heading_item').removeClass('active is-open is-selected');
    }

    if (pinSubscribeOpen && widgetWrapper.length) {
        var subscribeHeading = widgetWrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').first();
        if (subscribeHeading.length) {
            subscribeHeading.addClass('is-open');
        }
    } else {
        heading.addClass('active is-selected');
    }

    if (widgetWrapper.length && widgetWrapper.hasClass('custom_boc_subscripe_full--v5')) {
        if (current_tab === '3') {
            setAtcSubV5ModeVisual(widgetWrapper, true);
        } else if (current_tab === '1') {
            setAtcSubV5ModeVisual(widgetWrapper, false);
        }
    }

    if (widgetWrapper.length && widgetWrapper.hasClass('js-atc-sub-v4')) {
        widgetWrapper.find('.js-one-time-card').toggleClass('is-selected', current_tab === '2');
        widgetWrapper.find('.js-ampm-bundle-card').toggleClass('is-active', current_tab === '3');
    }

    scopedRoot.find('.price_subscription_trigger').removeClass('active');

    // V1/V2/V3 safeguard: subscribe heading can be rendered without selling_plan.
    // Always derive subscription ids from the active frequency tab when tab=1 is selected.
    if (current_tab === '1' && widgetWrapper.length && !isV9PlainQuantity) {
        var activeDurationItem = widgetWrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item.active[data_tab]')
            .first();
        if (!activeDurationItem.length) {
            activeDurationItem = widgetWrapper
                .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab]')
                .first();
        }

        if (activeDurationItem.length) {
            var durationSellingPlan = activeDurationItem.attr('selling_plan');
            var durationVariantId = activeDurationItem.attr('variant_id');

            if (durationSellingPlan !== undefined && durationSellingPlan !== null && String(durationSellingPlan).trim() !== '') {
                selling_plan = String(durationSellingPlan);
                heading.attr('selling_plan', selling_plan);
            }
            if (durationVariantId !== undefined && durationVariantId !== null && String(durationVariantId).trim() !== '') {
                variant_id = String(durationVariantId);
                heading.attr('variant_id', variant_id);
            }
        }
    }

    if (current_tab === '1' && isV9PlainQuantity) {
        selling_plan = '';
        heading.attr('selling_plan', '');
    }

    if (scopedForm.length) {
        scopedForm.find('[name="id"]').val(variant_id);
    }
    if (selling_plan != "") {
        if (scopedForm.length) {
            scopedForm.find('[name="selling_plan"]').removeAttr('disabled');
            scopedForm.find('[name="selling_plan"]').val(selling_plan);
        }
    } else {
        if (scopedForm.length) {
            scopedForm.find('[name="selling_plan"]').attr('disabled', 'disabled');
            scopedForm.find('[name="selling_plan"]').val(selling_plan);
        }
    }
    syncSubscriptionContentState(widgetWrapper);
    syncBetweenOptionsTextState(widgetWrapper);
    var atcPriceTriggers = scopedRoot.find('.custom_product_add_to_carts_main .price_subscription_trigger');
    atcPriceTriggers.hide();
    atcPriceTriggers.filter('[data_tab="' + current_tab + '"]').show();
    syncAmpmBundleCardState(widgetWrapper);
    syncAtcSubV9OneTimeState(widgetWrapper);
    applyAtcSubPackFrequencyCopy(widgetWrapper);
    updateAtcSubV2SubscribeLabel(widgetWrapper);
    syncManualTitleDiscounts(widgetWrapper);
    syncStickyAtcV2Card(widgetWrapper);
    syncAmpmMobileStickyCartPrice(widgetWrapper);
});

jQuery(document).on('click', '.js-one-time-card', function (event) {
    if (jQuery(event.target).closest('.custom_widget_subscription_heading_item').length) {
        return;
    }
    var toggle = jQuery(this).find('.custom_widget_subscription_heading_item');
    if (toggle.length) {
        toggle.trigger('click');
    }
});

jQuery(document).on('click', '.js-v5-subscribe-card', function (event) {
    if (jQuery(event.target).closest('.custom_widget_subscription_heading_item, .subscription_heading_member_item, select, option, button, a, input, label').length) {
        return;
    }
    var toggle = jQuery(this).find('.custom_widget_subscription_heading_item[data_tab="1"]').first();
    if (toggle.length) {
        toggle.trigger('click');
    }
});

jQuery(document).on('click', '.js-ampm-bundle-card', function (event) {
    if (jQuery(event.target).closest('.custom_widget_subscription_heading_item, .js-ampm-bundle-interval').length) {
        return;
    }
    var toggle = jQuery(this).find('.js-ampm-bundle-heading');
    if (toggle.length) {
        toggle.trigger('click');
    }
});

jQuery(document).on('change', '.js-ampm-bundle-interval', function () {
    var select = jQuery(this);
    var option = select.find('option:selected');
    if (!option.length) return;

    var card = select.closest('.js-ampm-bundle-card');
    if (!card.length) {
        card = select.closest('.js-v3-inline-bundle');
    }
    var heading = card.find('.js-ampm-bundle-heading');
    var wrapper = select.closest('.custom_boc_subscripe_full');
    var isV9PlainQuantity = isAtcSubV9PlainQuantity(wrapper);

    var mainVariantId = option.attr('data-main-variant-id') || '';
    var mainSellingPlanId = option.attr('data-main-selling-plan-id') || '';
    var totalPriceMoney = option.attr('data-total-price-money') || '';
    var totalCompareMoney = option.attr('data-total-compare-money') || '';
    var mainTitle = option.attr('data-main-title') || '';
    var otherTitle = option.attr('data-other-title') || '';
    var mainShortTitle = option.attr('data-main-short-title') || mainTitle;
    var otherShortTitle = option.attr('data-other-short-title') || otherTitle;
    var bundleHeading = option.attr('data-bundle-heading') || '';
    var bundleSubtitle = option.attr('data-bundle-subtitle') || '';
    var bundlePerDay = option.attr('data-bundle-per-day') || '';
    var mainSubtitle = option.attr('data-main-subtitle') || '';
    var otherSubtitle = option.attr('data-other-subtitle') || '';
    var mainPriceMoney = option.attr('data-main-price-money') || '';
    var otherPriceMoney = option.attr('data-other-price-money') || '';
    var mainCompareMoney = option.attr('data-main-compare-money') || '';
    var otherCompareMoney = option.attr('data-other-compare-money') || '';
    var mainImage = option.attr('data-main-image') || '';
    var otherImage = option.attr('data-other-image') || '';
    var mainOneTimePriceMoney = option.attr('data-main-one-time-price-money') || '';
    var optionTab = option.attr('data-tab') || '1';

    syncAtcSubV2BundleIntervals(wrapper, optionTab, false);

    heading.attr('variant_id', mainVariantId);
    heading.attr('selling_plan', isV9PlainQuantity ? '' : mainSellingPlanId);

    var priceElm = card.find('.js-ampm-bundle-current-price');
    if (priceElm.length && totalPriceMoney) {
        priceElm.addClass('money');
        priceElm.text(totalPriceMoney);
    }

    var compareElm = card.find('.js-ampm-bundle-compare-price');
    if (compareElm.length) {
        compareElm.addClass('money');
        if (totalCompareMoney && totalCompareMoney !== totalPriceMoney) {
            compareElm.text(totalCompareMoney).show();
        } else {
            compareElm.text('').hide();
        }
    }

    var subscribeCurrentElm = wrapper.find('.js-atc-v4-subscribe-current-price').first();
    if (subscribeCurrentElm.length && totalPriceMoney) {
        subscribeCurrentElm.addClass('money');
        subscribeCurrentElm.text(totalPriceMoney);
    }

    var subscribeCompareElm = wrapper.find('.js-atc-v4-subscribe-compare-price').first();
    if (subscribeCompareElm.length) {
        subscribeCompareElm.addClass('money');
        if (totalCompareMoney && totalCompareMoney !== totalPriceMoney) {
            subscribeCompareElm.text(totalCompareMoney).show();
        } else {
            subscribeCompareElm.text('').hide();
        }
    }

    var useShortTitles = wrapper.hasClass('js-atc-sub-v4') || wrapper.hasClass('custom_boc_subscripe_full--v8');
    card.find('.js-ampm-main-title').text(useShortTitles ? mainShortTitle : mainTitle);
    card.find('.js-ampm-other-title').text(useShortTitles ? otherShortTitle : otherTitle);
    if (bundleHeading) {
        card.find('.js-ampm-bundle-title').text(bundleHeading);
    }

    var bundleSubtitleElm = card.find('.js-ampm-bundle-subtitle');
    if (bundleSubtitleElm.length) {
        if (bundleSubtitle) {
            bundleSubtitleElm.text(bundleSubtitle).removeClass('is-hidden').show();
        } else {
            bundleSubtitleElm.text('').addClass('is-hidden').hide();
        }
    }

    var bundlePerDayElm = card.find('.js-ampm-bundle-per-day');
    if (bundlePerDayElm.length) {
        if (bundlePerDay) {
            bundlePerDayElm.text(bundlePerDay).show();
        } else {
            bundlePerDayElm.text('').hide();
        }
    }

    var mainSubtitleElm = card.find('.js-ampm-main-subtitle');
    if (mainSubtitleElm.length) {
        if (mainSubtitle) {
            mainSubtitleElm.text(mainSubtitle).removeClass('is-hidden').show();
        } else {
            mainSubtitleElm.text('').addClass('is-hidden').hide();
        }
    }

    var otherSubtitleElm = card.find('.js-ampm-other-subtitle');
    if (otherSubtitleElm.length) {
        if (otherSubtitle) {
            otherSubtitleElm.text(otherSubtitle).removeClass('is-hidden').show();
        } else {
            otherSubtitleElm.text('').addClass('is-hidden').hide();
        }
    }

    card.find('.js-ampm-main-price').addClass('money').text(mainPriceMoney);
    card.find('.js-ampm-other-price').addClass('money').text(otherPriceMoney);

    var mainCompareElm = card.find('.js-ampm-main-compare');
    var otherCompareElm = card.find('.js-ampm-other-compare');
    mainCompareElm.addClass('money').text(mainCompareMoney);
    otherCompareElm.addClass('money').text(otherCompareMoney);
    if (mainCompareMoney && mainCompareMoney !== mainPriceMoney) {
        mainCompareElm.show();
    } else {
        mainCompareElm.hide();
    }
    if (otherCompareMoney && otherCompareMoney !== otherPriceMoney) {
        otherCompareElm.show();
    } else {
        otherCompareElm.hide();
    }

    if (mainImage) card.find('.js-ampm-main-image').attr('src', mainImage);
    if (otherImage) card.find('.js-ampm-other-image').attr('src', otherImage);

    var oneTimeHeading = wrapper.find('.js-atc-v4-one-time-heading').first();
    if (oneTimeHeading.length) {
        oneTimeHeading.attr('variant_id', mainVariantId);
        oneTimeHeading.attr('selling_plan', '');
    }

    var oneTimePriceElm = wrapper.find('.js-atc-v4-one-time-price').first();
    if (oneTimePriceElm.length && mainOneTimePriceMoney) {
        oneTimePriceElm.text(mainOneTimePriceMoney);
    }

    if (wrapper.hasClass('js-atc-sub-v2') && wrapper.hasClass('is-v2-ampm-active')) {
        var selectedPriceData = getAmpmBundleSelectedPriceData(wrapper);
        if (selectedPriceData) {
            updateAtcSubV2OneTimeBundlePrice(wrapper, selectedPriceData.priceMoney, selectedPriceData.compareMoney);
        }
    }

    if (heading.hasClass('active') && !wrapper.hasClass('js-atc-sub-v2')) {
        heading.trigger('click');
    } else {
        wrapper.find('[name="id"]').val(mainVariantId);
        if (wrapper.hasClass('js-atc-sub-v4') && oneTimeHeading.length && oneTimeHeading.hasClass('active')) {
            wrapper.find('[name="selling_plan"]').attr('disabled', 'disabled').val('');
        } else if (isV9PlainQuantity) {
            wrapper.find('[name="selling_plan"]').attr('disabled', 'disabled').val('');
        } else if (mainSellingPlanId !== '') {
            wrapper.find('[name="selling_plan"]').removeAttr('disabled').val(mainSellingPlanId);
        }
    }

    if (wrapper.hasClass('js-atc-sub-v2') && wrapper.hasClass('is-v2-ampm-active')) {
        var durationItem = wrapper
            .find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab="' + optionTab + '"]')
            .first();
        if (durationItem.length) {
            durationItem.trigger('click');
        } else {
            toggleAtcSubV2TextContent(wrapper, optionTab);
        }
    }

    // Guard: if a currency formatting library is present, ask it to re-scan updated money nodes.
    try {
        if (window.Currency && typeof window.Currency.convertAll === 'function') {
            window.Currency.convertAll();
        } else if (window.Shopify && window.Shopify.currency && typeof window.Shopify.currency.update === 'function') {
            window.Shopify.currency.update();
        }
    } catch (e) {}

    updateAtcSubV2SubscribeLabel(wrapper);
    syncAtcSubV9OneTimeState(wrapper);
    syncAtcSubV4State(wrapper);
    syncManualTitleDiscounts(wrapper);
    applyAtcSubPackFrequencyCopy(wrapper);
    syncStickyAtcV2Card(wrapper);
    syncAmpmMobileStickyCartPrice(wrapper);
});

jQuery(document).on('click', '.js-v2-bundle-choice', function () {
    var choice = jQuery(this).attr('data-choice');
    var wrapper = jQuery(this).closest('.js-atc-sub-v2');
    setAtcSubV2Mode(wrapper, choice === 'ampm');
});

function initArticleMobileGallery(scope) {
    var root = scope && scope.nodeType ? scope : document;
    var sections = root.querySelectorAll
        ? root.querySelectorAll('.main-product[data-ui-component="Product Details Article Section"], .main-product[data-ui-component="Main Product Section"]')
        : [];

    sections.forEach(function (section) {
        var mediaWrapper = section.querySelector('.product__media-wrapper--single-with-thumbnails');
        if (!mediaWrapper) {
            return;
        }

        var slider = mediaWrapper.querySelector('.product-slideshow__items');
        if (!slider) {
            return;
        }

        var mobilePagination = mediaWrapper.querySelector('.product-slideshow__slider .js-carousel-pagination');
        var prevButton = mobilePagination
            ? mobilePagination.querySelector('.js-carousel-prev-btn')
            : mediaWrapper.querySelector('.product-slideshow__slider .js-carousel-prev-btn');
        var nextButton = mobilePagination
            ? mobilePagination.querySelector('.js-carousel-next-btn')
            : mediaWrapper.querySelector('.product-slideshow__slider .js-carousel-next-btn');
        var counterCurrent = mediaWrapper.querySelectorAll('.product-slideshow__slider .js-carousel-counter-current, .pdp-gallery-dots-row .js-carousel-counter-current');
        var counterTotal = mediaWrapper.querySelectorAll('.product-slideshow__slider .js-carousel-counter-total, .pdp-gallery-dots-row .js-carousel-counter-total');
        var dotsContainer = mediaWrapper.querySelector('[data-swipe-dots]');
        var desktopNavigationEnabled = mobilePagination && mobilePagination.dataset.desktopGalleryNavigation === 'true';

        function getSlides() {
            return Array.prototype.filter.call(
                slider.querySelectorAll('.product-slideshow__item--mobile, .product-slideshow__item--shared'),
                function (slide) {
                    return window.getComputedStyle(slide).display !== 'none';
                }
            );
        }

        function getCurrentIndex(slides) {
            if (!slides.length) {
                return 0;
            }

            var sliderRect = slider.getBoundingClientRect();
            var bestIndex = 0;
            var bestOffset = Infinity;

            slides.forEach(function (slide, index) {
                var offset = Math.abs(slide.getBoundingClientRect().left - sliderRect.left);
                if (offset < bestOffset) {
                    bestOffset = offset;
                    bestIndex = index;
                }
            });

            return bestIndex;
        }

        function getDesktopThumbButtons() {
            return Array.prototype.filter.call(
                mediaWrapper.querySelectorAll('.product-slideshow__thumbnail .js-slideshow-btn-thumb'),
                function (button) {
                    var thumb = button.closest('.js-product-slideshow-thumb');
                    var target = button.dataset.target;
                    return (
                        target &&
                        thumb &&
                        thumb.getClientRects().length > 0 &&
                        window.getComputedStyle(thumb).display !== 'none' &&
                        slider.querySelector('[data-media-id="' + target + '"]')
                    );
                }
            );
        }

        function getDesktopGalleryState() {
            var buttons = getDesktopThumbButtons();
            var activeTarget = null;
            var activeThumb = mediaWrapper.querySelector('.product-slideshow__thumbnail .js-product-slideshow-thumb.is-active-item .js-slideshow-btn-thumb');
            var activeSlide = slider.querySelector('.js-product-slideshow-item.d-block');

            if (activeThumb) {
                activeTarget = activeThumb.dataset.target;
            }
            if (!activeTarget && activeSlide) {
                activeTarget = activeSlide.dataset.mediaId;
            }

            var currentIndex = buttons.findIndex(function (button) {
                return button.dataset.target === activeTarget;
            });

            if (currentIndex < 0) {
                currentIndex = 0;
            }

            return {
                buttons: buttons,
                currentIndex: currentIndex,
                total: buttons.length
            };
        }

        function setGalleryButtonState(button, disabled) {
            if (!button) {
                return;
            }

            button.style.setProperty('display', 'flex', 'important');
            button.disabled = disabled;
            button.style.setProperty('visibility', disabled ? 'hidden' : 'visible', 'important');
            button.style.setProperty('pointer-events', disabled ? 'none' : 'auto', 'important');
            button.style.setProperty('opacity', disabled ? '0' : '1', 'important');
        }

        function updateDesktopUi() {
            if (!desktopNavigationEnabled) {
                return false;
            }

            var state = getDesktopGalleryState();
            var hideControls = state.total <= 1;

            setGalleryButtonState(prevButton, hideControls || state.currentIndex === 0);
            setGalleryButtonState(nextButton, hideControls || state.currentIndex >= state.total - 1);

            return true;
        }

        function buildDots(slides) {
            if (!dotsContainer) {
                return;
            }

            dotsContainer.innerHTML = '';

            slides.forEach(function (_, index) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'pdp-gallery-dot';
                dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
                dot.addEventListener('click', function () {
                    slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                });
                dotsContainer.appendChild(dot);
            });
        }

        function updateUi() {
            if (window.innerWidth >= 750) {
                updateDesktopUi();
                return;
            }

            var slides = getSlides();
            if (!slides.length) {
                return;
            }

            var currentIndex = getCurrentIndex(slides);
            var total = slides.length;

            counterCurrent.forEach(function (node) {
                node.textContent = String(currentIndex + 1);
            });
            counterTotal.forEach(function (node) {
                node.textContent = String(total);
            });

            if (prevButton) {
                prevButton.style.setProperty('display', 'flex', 'important');
                prevButton.disabled = currentIndex === 0;
                prevButton.style.setProperty('visibility', currentIndex === 0 ? 'hidden' : 'visible', 'important');
                prevButton.style.setProperty('pointer-events', currentIndex === 0 ? 'none' : 'auto', 'important');
                prevButton.style.setProperty('opacity', currentIndex === 0 ? '0' : '1', 'important');
            }
            if (nextButton) {
                nextButton.style.setProperty('display', 'flex', 'important');
                nextButton.disabled = currentIndex >= total - 1;
                nextButton.style.setProperty('visibility', currentIndex >= total - 1 ? 'hidden' : 'visible', 'important');
                nextButton.style.setProperty('pointer-events', currentIndex >= total - 1 ? 'none' : 'auto', 'important');
                nextButton.style.setProperty('opacity', currentIndex >= total - 1 ? '0' : '1', 'important');
            }

            if (dotsContainer) {
                Array.prototype.forEach.call(dotsContainer.children, function (dot, index) {
                    dot.classList.toggle('is-active', index === currentIndex);
                });
            }
        }

        function scrollByStep(direction) {
            var slides = getSlides();
            if (!slides.length) {
                return;
            }

            var currentIndex = getCurrentIndex(slides);
            var nextIndex = currentIndex + direction;
            if (nextIndex < 0) {
                nextIndex = 0;
            }
            if (nextIndex > slides.length - 1) {
                nextIndex = slides.length - 1;
            }

            slides[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }

        function showDesktopSlideByStep(direction) {
            var state = getDesktopGalleryState();
            if (!state.total) {
                return;
            }

            var nextIndex = state.currentIndex + direction;
            if (nextIndex < 0) {
                nextIndex = 0;
            }
            if (nextIndex > state.total - 1) {
                nextIndex = state.total - 1;
            }

            if (state.buttons[nextIndex]) {
                state.buttons[nextIndex].click();
                window.requestAnimationFrame(updateUi);
            }
        }

        if (!slider.dataset.articleMobileGalleryBound) {
            slider.dataset.articleMobileGalleryBound = 'true';

            slider.addEventListener('scroll', function () {
                window.requestAnimationFrame(updateUi);
            }, { passive: true });

            var onResize = function () {
                if (!document.contains(slider)) {
                    window.removeEventListener('resize', onResize);
                    return;
                }
                window.requestAnimationFrame(updateUi);
            };
            window.addEventListener('resize', onResize);

            Array.prototype.forEach.call(mediaWrapper.querySelectorAll('.product-slideshow__thumbnail .js-slideshow-btn-thumb'), function (button) {
                button.addEventListener('click', function () {
                    window.requestAnimationFrame(updateUi);
                });
            });

            if (prevButton) {
                prevButton.addEventListener('click', function (event) {
                    if (window.innerWidth >= 750) {
                        if (!desktopNavigationEnabled) {
                            return;
                        }
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        showDesktopSlideByStep(-1);
                        return;
                    }
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    scrollByStep(-1);
                }, true);
            }

            if (nextButton) {
                nextButton.addEventListener('click', function (event) {
                    if (window.innerWidth >= 750) {
                        if (!desktopNavigationEnabled) {
                            return;
                        }
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        showDesktopSlideByStep(1);
                        return;
                    }
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    scrollByStep(1);
                }, true);
            }
        }

        var slides = getSlides();
        buildDots(slides);
        updateUi();
    });
}

function initProductPurchaseUi(scope) {
    var root = scope && scope.length ? scope : jQuery(document);

    initAtcSubV2(root);
    initAtcSubV4(root);
    syncAmpmBundleCardState(root);
    syncSubscriptionContentState(root);
    syncAtcSubV9OneTimeState(root);
    syncBetweenOptionsTextState(root);
    applyAtcSubPackFrequencyCopy(root);
    syncStickyAtcV2Card(root);
    syncAmpmMobileStickyCartPrice(root);
    syncManualTitleDiscounts(root);
    initStatCardCounters(root);

    if (root.length) {
        root.each(function () {
            initArticleMobileGallery(this);
        });
    } else {
        initArticleMobileGallery(document);
    }
}

jQuery(function () {
    initProductPurchaseUi(jQuery(document));
    window.setTimeout(function () {
        syncAmpmMobileStickyCartPrice(jQuery(document));
    }, 50);
});

jQuery(document).on('shopify:section:load', function (event) {
    var sectionRoot = event && event.target ? jQuery(event.target) : jQuery(document);
    initProductPurchaseUi(sectionRoot);
});

function parseStatCardCounterTarget(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return null;
    }

    var source = String(rawValue).trim();
    if (!source) {
        return null;
    }

    var match = source.match(/^([^0-9\-+]*)(-?\d+(?:\.(\d+))?)(.*)$/);
    if (!match) {
        return null;
    }

    var numberValue = parseFloat(match[2]);
    if (isNaN(numberValue)) {
        return null;
    }

    return {
        prefix: match[1] || '',
        value: numberValue,
        decimals: match[3] ? match[3].length : 0,
        suffix: match[4] || ''
    };
}

function formatStatCardCounterValue(parts, numericValue) {
    if (!parts) {
        return '';
    }

    var safeValue = typeof numericValue === 'number' && !isNaN(numericValue) ? numericValue : 0;
    return parts.prefix + safeValue.toFixed(parts.decimals) + parts.suffix;
}

function animateStatCardValue(node, speedMs, delayMs) {
    if (!node || node.getAttribute('data-stat-card-counter-started') === 'true') {
        return;
    }

    var targetText = node.getAttribute('data-stat-card-target') || node.textContent || '';
    var parts = parseStatCardCounterTarget(targetText);
    if (!parts) {
        node.setAttribute('data-stat-card-counter-started', 'true');
        return;
    }

    node.setAttribute('data-stat-card-counter-started', 'true');

    var duration = Math.max(100, parseInt(speedMs, 10) || 1200);
    var delay = Math.max(0, parseInt(delayMs, 10) || 0);
    var startValue = 0;
    var endValue = parts.value;
    var decimalFactor = Math.pow(10, parts.decimals);

    window.setTimeout(function () {
        var startTime = null;

        function step(timestamp) {
            if (startTime === null) {
                startTime = timestamp;
            }

            var progress = Math.min((timestamp - startTime) / duration, 1);
            var currentValue = startValue + ((endValue - startValue) * progress);
            var roundedValue = Math.round(currentValue * decimalFactor) / decimalFactor;

            node.textContent = formatStatCardCounterValue(parts, roundedValue);

            if (progress < 1) {
                window.requestAnimationFrame(step);
                return;
            }

            node.textContent = targetText;
        }

        node.textContent = formatStatCardCounterValue(parts, startValue);
        window.requestAnimationFrame(step);
    }, delay);
}

function isStatCardBlockActuallyVisible(node) {
    if (!node || !node.isConnected) {
        return false;
    }

    if (node.closest('.is-content-switcher-hidden')) {
        return false;
    }

    if (!node.getClientRects || !node.getClientRects().length) {
        return false;
    }

    var current = node;
    while (current && current.nodeType === 1) {
        var style = window.getComputedStyle(current);
        if (
            style.display === 'none' ||
            style.visibility === 'hidden' ||
            style.visibility === 'collapse' ||
            style.opacity === '0'
        ) {
            return false;
        }
        current = current.parentElement;
    }

    return true;
}

function isStatCardBlockInViewport(node) {
    if (!node || !node.getBoundingClientRect) {
        return false;
    }

    var rect = node.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var triggerPoint = viewportHeight * 0.9;
    return rect.bottom > 0 && rect.top < triggerPoint;
}

function prepareStatCardValue(node) {
    if (!node || node.getAttribute('data-stat-card-counter-prepared') === 'true') {
        return;
    }

    var targetText = node.getAttribute('data-stat-card-target') || node.textContent || '';
    var parts = parseStatCardCounterTarget(targetText);
    if (!parts) {
        node.setAttribute('data-stat-card-counter-prepared', 'true');
        return;
    }

    node.textContent = formatStatCardCounterValue(parts, 0);
    node.setAttribute('data-stat-card-counter-prepared', 'true');
}

function checkPendingStatCardCounters() {
    var pendingBlocks = window.__pendingStatCardCounterBlocks || [];
    if (!pendingBlocks.length) {
        return;
    }

    window.__pendingStatCardCounterBlocks = pendingBlocks.filter(function (block) {
        if (!block || !block.isConnected) {
            return false;
        }

        var values = block.querySelectorAll('[data-stat-card-value]');
        var hasStarted = Array.prototype.some.call(values, function (node) {
            return node.getAttribute('data-stat-card-counter-started') === 'true';
        });

        if (hasStarted) {
            return false;
        }

        if (!isStatCardBlockActuallyVisible(block) || !isStatCardBlockInViewport(block)) {
            return true;
        }

        var speedMs = block.getAttribute('data-stat-card-counter-speed') || '1200';
        var offsetDelayMs = parseInt(block.getAttribute('data-stat-card-counter-offset'), 10) || 0;

        Array.prototype.forEach.call(values, function (node, index) {
            animateStatCardValue(node, speedMs, offsetDelayMs * index);
        });

        return false;
    });
}

function initStatCardCounters(scope) {
    var root = scope && scope.length ? scope : jQuery(document);
    var isDocumentScope = root.length && root[0] === document;

    if (isDocumentScope && document.readyState !== 'complete') {
        if (!window.__statCardCountersDeferredToLoad) {
            window.__statCardCountersDeferredToLoad = true;
            window.addEventListener('load', function () {
                initStatCardCounters(jQuery(document));
            }, { once: true });
        }
        return;
    }

    var blocks = root.hasClass('pdp-stat-cards-block')
        ? root
        : root.find('.pdp-stat-cards-block');

    if (!blocks.length) {
        return;
    }

    blocks.each(function () {
        var block = this;
        var enabled = String(block.getAttribute('data-stat-card-counter-enabled')) !== 'false';
        if (!enabled) {
            return;
        }

        var speedMs = block.getAttribute('data-stat-card-counter-speed') || '1200';
        var offsetDelayMs = parseInt(block.getAttribute('data-stat-card-counter-offset'), 10) || 0;
        var values = block.querySelectorAll('[data-stat-card-value]');

        if (!values.length) {
            return;
        }

        function hasStartedCounters() {
            return Array.prototype.some.call(values, function (node) {
                return node.getAttribute('data-stat-card-counter-started') === 'true';
            });
        }

        Array.prototype.forEach.call(values, function (node) {
            prepareStatCardValue(node);
        });

        if (block.getAttribute('data-stat-card-counter-bound') === 'true') {
            if (hasStartedCounters()) {
                return;
            }
            if (!window.__pendingStatCardCounterBlocks) {
                window.__pendingStatCardCounterBlocks = [];
            }
            if (window.__pendingStatCardCounterBlocks.indexOf(block) === -1) {
                window.__pendingStatCardCounterBlocks.push(block);
            }
            return;
        }

        block.setAttribute('data-stat-card-counter-bound', 'true');
        if (!window.__pendingStatCardCounterBlocks) {
            window.__pendingStatCardCounterBlocks = [];
        }
        if (window.__pendingStatCardCounterBlocks.indexOf(block) === -1) {
            window.__pendingStatCardCounterBlocks.push(block);
        }
    });

    checkPendingStatCardCounters();
}

if (!window.__statCardCountersRefreshBound) {
    window.__statCardCountersRefreshBound = true;
    var statCardRefreshTimeout = null;
    var statCardBootstrapInterval = null;
    var statCardBootstrapAttempts = 0;

    var refreshStatCardCounters = function () {
        if (!window.jQuery || typeof window.initStatCardCounters !== 'function') {
            return;
        }

        window.requestAnimationFrame(function () {
            window.initStatCardCounters(window.jQuery(document));
            checkPendingStatCardCounters();
        });
    };

    var scheduleStatCardCounterRefresh = function (delay) {
        if (statCardRefreshTimeout) {
            window.clearTimeout(statCardRefreshTimeout);
        }
        statCardRefreshTimeout = window.setTimeout(function () {
            refreshStatCardCounters();
        }, Math.max(0, delay || 0));
    };

    window.addEventListener('resize', refreshStatCardCounters);
    window.addEventListener('orientationchange', refreshStatCardCounters);
    document.addEventListener('product-composer:content-switcher-change', refreshStatCardCounters);
    document.addEventListener('product-composer:mobile-placement-sync', refreshStatCardCounters);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            refreshStatCardCounters();
            scheduleStatCardCounterRefresh(120);
            scheduleStatCardCounterRefresh(360);
            scheduleStatCardCounterRefresh(900);
        }, { once: true });
    } else {
        refreshStatCardCounters();
        scheduleStatCardCounterRefresh(120);
        scheduleStatCardCounterRefresh(360);
        scheduleStatCardCounterRefresh(900);
    }

    window.addEventListener('load', function () {
        refreshStatCardCounters();
        scheduleStatCardCounterRefresh(180);
        scheduleStatCardCounterRefresh(700);
    }, { once: true });

    var onScrollStatCardRefresh = function () {
        scheduleStatCardCounterRefresh(60);
    };
    window.addEventListener('scroll', onScrollStatCardRefresh, { passive: true });

    window.setInterval(function () {
        checkPendingStatCardCounters();
    }, 250);

    statCardBootstrapInterval = window.setInterval(function () {
        statCardBootstrapAttempts += 1;
        refreshStatCardCounters();

        if (statCardBootstrapAttempts >= 40) {
            window.clearInterval(statCardBootstrapInterval);
        }
    }, 150);
}

// Keep helper text visibility in sync even when third-party scripts toggle classes without click events.
(function () {
    if (!document.body || !document.body.classList.contains('template-product')) {
        return;
    }
    var subscriptionHeadingItems = Array.prototype.slice.call(
        document.querySelectorAll('.custom_widget_subscription_heading_item')
    );
    if (!subscriptionHeadingItems.length) {
        return;
    }

    var observer = new MutationObserver(function (mutations) {
        var shouldSync = false;
        for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (m.type === 'attributes' && m.attributeName === 'class') {
                var target = m.target;
                if (target && target.classList && target.classList.contains('custom_widget_subscription_heading_item')) {
                    shouldSync = true;
                    break;
                }
            }
        }
        if (shouldSync) {
            syncBetweenOptionsTextState(jQuery(document));
        }
    });

    subscriptionHeadingItems.forEach(function (node) {
        observer.observe(node, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
})();

// Custom judge mobile mount and inline video playback.
(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function initCustomJudgeRoot(root) {
    if (!root || root.dataset.customJudgeInit === 'true') return;

    var widget = root.querySelector('[data-judgeme-product-reviews]');
    var stripCandidates = toArray(root.querySelectorAll('[data-custom-judge-strip]'));
    var sourceStrip = stripCandidates.find(function (node) {
      return node.parentElement && node.parentElement.classList.contains('custom-judge__inner');
    }) || stripCandidates[0];
    var strip = sourceStrip;
    var modal = root.querySelector('[data-custom-judge-modal]');

    if (!widget || !sourceStrip) return;

    root.dataset.customJudgeInit = 'true';
    root.dataset.customJudgeMounted = 'false';

    if (!window.setSidebarVideoThumb) {
      window.setSidebarVideoThumb = function (dialogId, videoIndex) {
        var dialog = document.getElementById(dialogId);
        if (!dialog) return;

        toArray(dialog.querySelectorAll('[data-sidebar-video-pane]')).forEach(function (pane) {
          var isActive = pane.getAttribute('data-sidebar-video-index') === String(videoIndex);
          pane.classList.toggle('is-active', isActive);
          pane.toggleAttribute('hidden', !isActive);

          var paneVideo = pane.querySelector('video');
          if (paneVideo && !isActive) {
            paneVideo.pause();
            try { paneVideo.currentTime = 0; } catch (error) {}
          } else if (paneVideo) {
            // Play one tick later: the dialog opens after this runs. A timeout,
            // not rAF, so it still fires when the tab is backgrounded. The click
            // is the gesture that permits unmuted playback; a refusal is a
            // no-op because the video keeps its controls.
            setTimeout(function () {
              var played = paneVideo.play();
              if (played && typeof played.catch === 'function') played.catch(function () {});
            }, 0);
          }
        });
      };
    }

    stripCandidates.forEach(function (node) {
      if (node !== sourceStrip) node.remove();
    });

    var mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    var mobileCardsPerRow = Number(root.dataset.customJudgeMobileCards || 2);
    var teardownMobileLoop = null;
    var mountRetryTimeout = null;
    var isDynamicVideoReviews = root.dataset.customJudgeVideoSource === 'dynamic';
    var onlyDynamicVideoReviews = root.dataset.customJudgeOnlyVideos !== 'false';
    var useUploadedFallback = root.dataset.customJudgeUseUploadedFallback === 'true';
    var uploadedFallbackTemplate = root.querySelector('[data-custom-judge-uploaded-fallback]');
    var playIconTemplate = root.querySelector('[data-custom-judge-play-icon]');

    function shouldPlayInline() {
      return mobileMediaQuery.matches
        ? root.dataset.customJudgeInlineMobile === 'true'
        : root.dataset.customJudgeInlineDesktop === 'true';
    }

    function pauseInlineVideos(exceptCard) {
      toArray(root.querySelectorAll('[data-custom-judge-card]')).forEach(function (card) {
        var video = card.querySelector('.custom-judge__inline-video');
        var isExcept = exceptCard && card === exceptCard;
        if (!video || isExcept) return;
        video.pause();
        video.controls = false;
        video.removeAttribute('controls');
        card.classList.remove('is-inline-playing');
        if (card.dataset.customJudgeMode === 'inline') {
          card.setAttribute('aria-pressed', 'false');
        }
      });
    }

    function pauseModalVideos() {
      if (!modal) return;
      toArray(modal.querySelectorAll('video')).forEach(function (video) {
        video.pause();
        try { video.currentTime = 0; } catch (error) {}
      });
    }

    function syncCardMode(card) {
      if (!card) return;

      var hasInlineVideo = !!card.querySelector('.custom-judge__inline-video');
      var isInline = shouldPlayInline() && hasInlineVideo;
      card.dataset.customJudgeMode = isInline ? 'inline' : 'modal';

      if (isInline) {
        card.removeAttribute('aria-haspopup');
        card.setAttribute('aria-pressed', card.classList.contains('is-inline-playing') ? 'true' : 'false');
        return;
      }

      card.classList.remove('is-inline-playing');
      card.removeAttribute('aria-pressed');
      if (modal) {
        card.setAttribute('aria-haspopup', 'dialog');
      } else {
        card.removeAttribute('aria-haspopup');
      }
    }

    function syncAllCardModes() {
      pauseInlineVideos();
      toArray(root.querySelectorAll('[data-custom-judge-card]')).forEach(syncCardMode);
    }

    function playActiveModalVideo() {
      if (!modal) return;
      var activeVideo = modal.querySelector('[data-sidebar-video-pane].is-active video');
      if (!activeVideo) return;

      activeVideo.controls = true;
      activeVideo.playsInline = true;
      activeVideo.setAttribute('playsinline', '');
      activeVideo.setAttribute('webkit-playsinline', '');
      activeVideo.muted = mobileMediaQuery.matches;
      activeVideo.play().catch(function () {
        activeVideo.muted = true;
        activeVideo.setAttribute('muted', '');
        activeVideo.play().catch(function () {});
      });
    }

    if (modal) {
      modal.addEventListener('opened', playActiveModalVideo);
      modal.addEventListener('closed', pauseModalVideos);
    }

    function prepareInlineVideo(video) {
      if (video.dataset.customJudgePrepared === 'true') return;
      video.dataset.customJudgePrepared = 'true';

      var card = video.closest('[data-custom-judge-card]');
      video.controls = false;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.disablePictureInPicture = true;
      video.disableRemotePlayback = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      video.removeAttribute('controls');
      video.load();
      video.addEventListener('ended', function () {
        if (!card) return;
        video.controls = false;
        video.removeAttribute('controls');
        card.classList.remove('is-inline-playing');
        if (card.dataset.customJudgeMode === 'inline') {
          card.setAttribute('aria-pressed', 'false');
        }
      });
    }

    function triggerNativeJudgeMedia(nativeSource) {
      if (!nativeSource) return;

      function preventNativeNavigation(event) {
        event.preventDefault();
      }

      nativeSource.addEventListener('click', preventNativeNavigation, { once: true });
      nativeSource.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    }

    function getDynamicVideoEmbedSource(dataNode, imageNode) {
      var iframeSrc = dataNode && (dataNode.getAttribute('data-iframe-src') || dataNode.getAttribute('data-video-url') || dataNode.getAttribute('data-video-src') || dataNode.getAttribute('data-video'));
      var externalId = dataNode && dataNode.getAttribute('data-external-id');

      if ((!iframeSrc || iframeSrc === 'undefined') && imageNode) {
        iframeSrc = imageNode.getAttribute('data-iframe-src') || imageNode.getAttribute('data-video-url') || imageNode.getAttribute('data-video-src') || imageNode.getAttribute('data-video');
        externalId = externalId || imageNode.getAttribute('data-external-id');
      }

      if (iframeSrc && iframeSrc !== 'undefined') {
        return iframeSrc.replace(/player\.vimeo\.com\/videos\//, 'player.vimeo.com/video/');
      }
      if (!externalId || externalId === 'undefined') return '';
      if (/^[a-f0-9]{32}$/i.test(externalId)) return 'https://iframe.videodelivery.net/' + externalId;
      if (/^\d+$/.test(externalId)) return 'https://player.vimeo.com/video/' + externalId;
      return '';
    }

    function getDynamicJudgeIframeDialog() {
      var dialog = document.getElementById('customJudgeDynamicVideoDialog');
      if (dialog) return dialog;

      dialog = document.createElement('div');
      dialog.id = 'customJudgeDynamicVideoDialog';
      dialog.className = 'custom-judge-dynamic-dialog';
      dialog.hidden = true;
      dialog.innerHTML = [
        '<div class="custom-judge-dynamic-dialog__backdrop" data-custom-judge-dynamic-close></div>',
        '<div class="custom-judge-dynamic-dialog__panel" role="dialog" aria-modal="true" aria-label="Review media">',
        '<button type="button" class="custom-judge-dynamic-dialog__close" aria-label="Close review media" data-custom-judge-dynamic-close>&times;</button>',
        '<div class="custom-judge-dynamic-dialog__frame-shell"></div>',
        '</div>'
      ].join('');
      document.body.appendChild(dialog);

      dialog.addEventListener('click', function (event) {
        if (!event.target.closest('[data-custom-judge-dynamic-close]')) return;
        closeDynamicJudgeIframeDialog(dialog);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !dialog.hidden) closeDynamicJudgeIframeDialog(dialog);
      });

      return dialog;
    }

    function closeDynamicJudgeIframeDialog(dialog) {
      if (!dialog) return;
      var frameShell = dialog.querySelector('.custom-judge-dynamic-dialog__frame-shell');
      if (frameShell) frameShell.innerHTML = '';
      dialog.hidden = true;
      document.body.classList.remove('custom-judge-dynamic-dialog-open');
    }

    function openDynamicJudgeIframeDialog(src, trigger) {
      if (!src) return false;

      var dialog = getDynamicJudgeIframeDialog();
      var frameShell = dialog.querySelector('.custom-judge-dynamic-dialog__frame-shell');
      if (!frameShell) return false;

      frameShell.innerHTML = '';
      frameShell.classList.remove('custom-judge-dynamic-dialog__frame-shell--image');
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'Video review');
      frameShell.appendChild(iframe);
      var panel = dialog.querySelector('.custom-judge-dynamic-dialog__panel');
      var closeButton = dialog.querySelector('.custom-judge-dynamic-dialog__close');
      if (panel) panel.setAttribute('aria-label', 'Video review');
      if (closeButton) closeButton.setAttribute('aria-label', 'Close video review');
      dialog.hidden = false;
      document.body.classList.add('custom-judge-dynamic-dialog-open');

      if (closeButton) closeButton.focus({ preventScroll: true });
      dialog.dataset.returnFocusTo = trigger ? 'true' : 'false';
      return true;
    }

    function openDynamicJudgeImageDialog(src, trigger) {
      if (!src) return false;

      var dialog = getDynamicJudgeIframeDialog();
      var frameShell = dialog.querySelector('.custom-judge-dynamic-dialog__frame-shell');
      if (!frameShell) return false;

      frameShell.innerHTML = '';
      frameShell.classList.add('custom-judge-dynamic-dialog__frame-shell--image');
      var image = document.createElement('img');
      image.className = 'custom-judge-dynamic-dialog__image';
      image.src = src;
      image.alt = 'Review image';
      frameShell.appendChild(image);
      var panel = dialog.querySelector('.custom-judge-dynamic-dialog__panel');
      var closeButton = dialog.querySelector('.custom-judge-dynamic-dialog__close');
      if (panel) panel.setAttribute('aria-label', 'Review image');
      if (closeButton) closeButton.setAttribute('aria-label', 'Close review image');
      dialog.hidden = false;
      document.body.classList.add('custom-judge-dynamic-dialog-open');

      if (closeButton) closeButton.focus({ preventScroll: true });
      dialog.dataset.returnFocusTo = trigger ? 'true' : 'false';
      return true;
    }

    function createCustomJudgePlayIcon() {
      if (playIconTemplate && playIconTemplate.content && playIconTemplate.content.firstElementChild) {
        return playIconTemplate.content.firstElementChild.cloneNode(true);
      }

      var play = document.createElement('span');
      play.className = 'custom-judge__video-play';
      play.innerHTML = '<svg class="custom-judge__video-play-icon" viewBox="0 0 30 30" aria-hidden="true" focusable="false"><circle cx="15" cy="15" r="15" fill="rgba(0,0,0,.42)"></circle><path d="M12 9.5v11l9-5.5-9-5.5Z" fill="#fff"></path></svg>';
      return play;
    }

    function resizeJudgeMeImageUrl(url, width) {
      if (!url || !width) return url || '';

      var isImgix = /judgeme\.imgix\.net/i.test(url);
      // Judge.me serves review photos from its own CDN (review-images.judge.me),
      // which sizes on `width` and ignores imgix's `w`. It hands us a 160px wide
      // thumbnail, far too small for the tall review cards.
      var isJudgeMeCdn = !isImgix && /\.judge\.me\//i.test(url);
      if (!isImgix && !isJudgeMeCdn) return url;

      var param = isImgix ? 'w' : 'width';

      try {
        var imageUrl = new URL(url, window.location.href);
        if (isImgix) imageUrl.searchParams.set('auto', imageUrl.searchParams.get('auto') || 'format');
        imageUrl.searchParams.set(param, String(width));
        return imageUrl.toString();
      } catch (error) {
        var existing = new RegExp('([?&])' + param + '=\\d+', 'i');
        if (existing.test(url)) return url.replace(existing, '$1' + param + '=' + width);
        return url + (url.indexOf('?') === -1 ? '?' : '&') + (isImgix ? 'auto=format&' : '') + param + '=' + width;
      }
    }

    function resizeVimeoImageUrl(url, width) {
      if (!url || !width || !/i\.vimeocdn\.com\/video\//i.test(url)) return url || '';

      // Judge.me supplies a cropped 200x150 Vimeo thumbnail. Requesting width
      // only restores the video's original aspect ratio as well as enough
      // resolution for the tall review cards.
      return url.replace(/_\d+x\d+(?=([?#]|$))/i, '_' + width + 'x');
    }

    function resizeReviewMediaUrl(url, width) {
      return resizeVimeoImageUrl(resizeJudgeMeImageUrl(url, width), width);
    }

    function getDynamicMediaItems(reviewWidget) {
      var mediaRoots = toArray(reviewWidget.querySelectorAll(
        '.jdgm-row-media, .jdgm-gallery-wrapper, .jdgm-rev__pics, .jdgm-rev__videos, .jdgm-rev__media'
      ));
      var candidateSelector = 'a, button, [role="button"], img, video, [style*="background-image"], [data-media-type], [data-iframe-src], [data-external-id], [data-video-url], [data-video], [data-video-src], [data-src], [data-href], [data-mfp-src]';
      var explicitVideoSelector = '.jdgm-gallery__thumbnail-wrapper[data-media-type="video"], .jdgm-rev__video-link, .jdgm-gallery-item--video, .jdgm-gallery__video, [class*="video"], [data-media-type="video"], [data-iframe-src], [data-external-id], [data-video-url], [data-video], [data-video-src]';
      var candidates = mediaRoots.length
        ? mediaRoots.reduce(function (items, mediaRoot) {
          return items.concat(toArray(mediaRoot.querySelectorAll(candidateSelector)));
        }, [])
        : toArray(reviewWidget.querySelectorAll(candidateSelector));
      candidates = candidates.concat(toArray(reviewWidget.querySelectorAll(explicitVideoSelector)));
      candidates = candidates.filter(function (node, index) {
        return candidates.indexOf(node) === index;
      });

      var items = candidates.map(function (node, sourceIndex) {
        if (node.closest('.custom-judge__videos')) return null;

        var source = node.closest(
          '.jdgm-gallery__thumbnail-wrapper[data-media-type], .jdgm-gallery__thumbnail-link, a, button, [role="button"], .jdgm-gallery__thumbnail, .jdgm-gallery-item, .jdgm-rev__pic-link, .jdgm-rev__video-link, [data-video-url], [data-video], [data-video-src], [data-mfp-src]'
        ) || node;
        var image = source.querySelector('img') || (node.tagName === 'IMG' ? node : null);
        var video = source.querySelector('video') || (node.tagName === 'VIDEO' ? node : null);
        var mediaDataNode = source.matches && (
          source.matches('[data-media-type], [data-iframe-src], [data-external-id], [data-video-url], [data-video-src], [data-video]')
        ) ? source : source.querySelector('[data-media-type], [data-iframe-src], [data-external-id], [data-video-url], [data-video-src], [data-video]');
        var iframeSrc = getDynamicVideoEmbedSource(mediaDataNode || source, image);
        var poster = '';
        var href = source.getAttribute('href') || source.getAttribute('data-href') || source.getAttribute('data-src') || source.getAttribute('data-mfp-src') || source.getAttribute('data-video-url') || source.getAttribute('data-video-src') || source.getAttribute('data-video') || '';
        var imageLargeSrc = image ? (image.getAttribute('data-mfp-src') || image.getAttribute('data-original') || image.getAttribute('data-src') || '') : '';
        var sourceClasses = String(source.className || '') + ' ' + String(node.className || '');
        var sourceDataset = Object.keys(source.dataset || {}).map(function (key) {
          return key + ':' + source.dataset[key];
        }).join(' ');
        var nodeDataset = Object.keys(node.dataset || {}).map(function (key) {
          return key + ':' + node.dataset[key];
        }).join(' ');
        var ariaText = [
          source.getAttribute('aria-label') || '',
          source.getAttribute('title') || '',
          source.getAttribute('data-title') || '',
          node.getAttribute('aria-label') || '',
          node.getAttribute('title') || ''
        ].join(' ');

        if (image) {
          poster = image.currentSrc || image.src || image.getAttribute('data-src') || image.getAttribute('data-original') || '';
        }

        if (!poster && video) {
          poster = video.poster || video.getAttribute('poster') || '';
        }

        if (!poster) {
          var styleNode = source.getAttribute('style') ? source : node;
          var match = (styleNode.getAttribute('style') || '').match(/background-image:\s*url\(["']?([^"')]+)["']?\)/i);
          poster = match ? match[1] : '';
        }

        var mediaSignature = [sourceClasses, sourceDataset, nodeDataset, ariaText, href, iframeSrc, poster, video ? (video.currentSrc || video.src || video.poster || '') : ''].join(' ').toLowerCase();
        var hasVideoHint = !!video || /\bvideo\b|jdgm-rev__video-link|jdgm-gallery(?:__)?video|jdgm-gallery-item--video|cloudflarestream\.com|stream\.cloudflare\.com|vimeocdn\.com|vimeo\.com|youtube\.com|youtu\.be|wistia|mux\.com|\.m3u8|\.mp4|\.mov|\.webm/.test(mediaSignature);
        var isVideoMedia = hasVideoHint;
        var isAllowedMedia = onlyDynamicVideoReviews ? isVideoMedia : (isVideoMedia || !!poster || !!href);
        if (!isAllowedMedia) return null;

        // The lightbox fills the viewport, so ask for more than the card poster.
        // Judge.me caps at the original upload, so this never upscales.
        var imageSrc = isVideoMedia ? '' : resizeReviewMediaUrl(imageLargeSrc || href || poster, 1600);
        poster = resizeReviewMediaUrl(poster, 960);

        var key = (isVideoMedia ? iframeSrc : '') || imageSrc || href || poster || source.getAttribute('data-src') || source.getAttribute('data-mfp-src') || '';
        if (isVideoMedia && !poster) return null;
        if (!key) return null;

        return {
          source: source,
          poster: poster,
          video: video,
          iframeSrc: iframeSrc,
          imageSrc: imageSrc,
          isVideoMedia: isVideoMedia,
          sourceIndex: sourceIndex,
          key: key
        };
      }).filter(Boolean).sort(function (a, b) {
        if (!onlyDynamicVideoReviews && a.isVideoMedia !== b.isVideoMedia) {
          return a.isVideoMedia ? -1 : 1;
        }

        return a.sourceIndex - b.sourceIndex;
      });

      var seen = {};
      return items.filter(function (item) {
        if (seen[item.key]) return false;
        seen[item.key] = true;
        return true;
      }).slice(0, 5);
    }

    function prepareFallbackCard(card) {
      card.removeAttribute('data-custom-judge-native-index');
      card.removeAttribute('data-custom-judge-iframe-src');
      card.dataset.customJudgeUploadedFallback = 'true';
      if (shouldPlayInline()) {
        card.classList.add('custom-judge__video-card--inline');
        toArray(card.querySelectorAll('video')).forEach(prepareInlineVideo);
      } else {
        card.classList.remove('custom-judge__video-card--inline', 'is-inline-playing');
        toArray(card.querySelectorAll('.custom-judge__inline-video')).forEach(function (video) {
          video.remove();
        });
      }
      return card;
    }

    function cloneFallbackTemplateCards() {
      if (!uploadedFallbackTemplate || !uploadedFallbackTemplate.content) return [];
      var fragment = uploadedFallbackTemplate.content.cloneNode(true);
      return toArray(fragment.querySelectorAll('[data-custom-judge-card]'));
    }

    function getUploadedFallbackCards(limit) {
      if (!useUploadedFallback || limit <= 0) return [];
      return cloneFallbackTemplateCards().slice(0, limit).map(prepareFallbackCard);
    }

    var urlProbeCache = {};

    function probeIframeUrl(url) {
      if (!url) return Promise.resolve(true);
      if (urlProbeCache[url]) return urlProbeCache[url];

      var vimeoMatch = url.match(/player\.vimeo\.com\/video\/(\d+)/);
      if (vimeoMatch) {
        var probeUrl = 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + vimeoMatch[1]);
        urlProbeCache[url] = fetch(probeUrl).then(function (r) {
          return r.ok;
        }).catch(function () {
          return true;
        });
        return urlProbeCache[url];
      }

      urlProbeCache[url] = Promise.resolve(true);
      return urlProbeCache[url];
    }

    function swapBrokenDynamicCards() {
      if (!useUploadedFallback || !uploadedFallbackTemplate) return;

      var dynamicCards = toArray(sourceStrip.querySelectorAll('[data-custom-judge-card]')).filter(function (card) {
        return card.dataset.customJudgeUploadedFallback !== 'true' && card.getAttribute('data-custom-judge-iframe-src');
      });
      if (!dynamicCards.length) return;

      var signatureAtStart = sourceStrip.dataset.customJudgeDynamicSignature;

      Promise.all(dynamicCards.map(function (card) {
        return probeIframeUrl(card.getAttribute('data-custom-judge-iframe-src')).then(function (valid) {
          return { card: card, valid: valid };
        });
      })).then(function (results) {
        if (sourceStrip.dataset.customJudgeDynamicSignature !== signatureAtStart) return;

        var broken = results.filter(function (r) { return !r.valid && r.card.isConnected; });
        if (!broken.length) return;

        var templateCards = cloneFallbackTemplateCards();
        if (!templateCards.length) return;

        var existingTrailing = toArray(sourceStrip.querySelectorAll('[data-custom-judge-uploaded-fallback="true"]'));
        var nextTemplateIndex = existingTrailing.length;

        broken.forEach(function (entry) {
          var brokenCard = entry.card;
          var replacement = null;

          if (nextTemplateIndex < templateCards.length) {
            replacement = prepareFallbackCard(templateCards[nextTemplateIndex]);
            nextTemplateIndex++;
          } else if (existingTrailing.length) {
            replacement = existingTrailing.shift();
          }

          if (replacement) {
            brokenCard.parentNode.replaceChild(replacement, brokenCard);
          } else {
            brokenCard.remove();
          }
        });
      });
    }

    function syncDynamicJudgeCards(reviewWidget) {
      if (!isDynamicVideoReviews) return true;

      var items = getDynamicMediaItems(reviewWidget);
      var signature = items.map(function (item) {
        return item.poster || item.source.getAttribute('href') || '';
      }).join('|') + '|inline:' + shouldPlayInline() + '|fallback:' + useUploadedFallback;
      sourceStrip.dataset.customJudgeDynamicCount = String(items.length);
      if (sourceStrip.dataset.customJudgeDynamicSignature === signature) {
        return items.length > 0;
      }

      sourceStrip.dataset.customJudgeDynamicSignature = signature;
      sourceStrip.innerHTML = '';

      items.forEach(function (item, index) {
        var nativeIndex = String(index + 1);
        item.source.setAttribute('data-custom-judge-native-source-index', nativeIndex);

        var card = document.createElement('button');
        card.type = 'button';
        card.className = item.isVideoMedia ? 'custom-judge__video-card' : 'custom-judge__video-card custom-judge__video-card--image';
        card.setAttribute('aria-label', (item.isVideoMedia ? 'View video review ' : 'View review image ') + nativeIndex);
        card.setAttribute('data-custom-judge-index', nativeIndex);
        card.setAttribute('data-custom-judge-native-index', nativeIndex);
        card.setAttribute('data-custom-judge-media-type', item.isVideoMedia ? 'video' : 'image');
        card.setAttribute('data-custom-judge-card', '');
        if (item.isVideoMedia) {
          card.setAttribute('aria-pressed', 'false');
        }
        if (item.isVideoMedia && item.iframeSrc) {
          card.setAttribute('data-custom-judge-iframe-src', item.iframeSrc);
        } else if (!item.isVideoMedia && item.imageSrc) {
          card.setAttribute('data-custom-judge-image-src', item.imageSrc);
        }

        var poster = document.createElement('span');
        poster.className = 'custom-judge__video-poster';
        if (item.poster) {
          poster.style.backgroundImage = 'url("' + item.poster.replace(/"/g, '%22') + '")';
        }
        card.appendChild(poster);

        if (item.isVideoMedia) {
          card.appendChild(createCustomJudgePlayIcon());
        }

        if (item.isVideoMedia && item.video && (root.dataset.customJudgeInlineMobile === 'true' || root.dataset.customJudgeInlineDesktop === 'true')) {
          var video = item.video.cloneNode(true);
          video.className = 'custom-judge__inline-video';
          video.removeAttribute('id');
          card.classList.add('custom-judge__video-card--inline');
          card.appendChild(video);
          prepareInlineVideo(video);
        }

        sourceStrip.appendChild(card);
      });

      getUploadedFallbackCards(5 - items.length).forEach(function (card) {
        sourceStrip.appendChild(card);
      });

      swapBrokenDynamicCards();

      return !!sourceStrip.querySelector('[data-custom-judge-card]');
    }

    toArray(root.querySelectorAll('.custom-judge__inline-video')).forEach(prepareInlineVideo);

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-custom-judge-card]');
      if (!card || !root.contains(card)) return;

      var isInline = card.dataset.customJudgeMode === 'inline';
      var video = card.querySelector('.custom-judge__inline-video');
      if (!isInline || !video) {
        var iframeSrc = card.getAttribute('data-custom-judge-iframe-src');
        if (iframeSrc && openDynamicJudgeIframeDialog(iframeSrc, card)) {
          return;
        }

        var imageSrc = card.getAttribute('data-custom-judge-image-src');
        if (imageSrc && openDynamicJudgeImageDialog(imageSrc, card)) {
          return;
        }

        var nativeIndex = card.getAttribute('data-custom-judge-native-index');
        var nativeSource = nativeIndex ? widget.querySelector('[data-custom-judge-native-source-index="' + nativeIndex + '"]') : null;
        if (nativeSource) {
          triggerNativeJudgeMedia(nativeSource);
          return;
        }

        if (!modal) return;
        pauseInlineVideos();
        pauseModalVideos();
        window.setSidebarVideoThumb(modal.id, card.getAttribute('data-custom-judge-index'));
        modal.showModal(card, true);
        return;
      }

      var isPlaying = card.classList.contains('is-inline-playing');
      if (isPlaying) {
        video.pause();
        video.controls = false;
        video.removeAttribute('controls');
        card.classList.remove('is-inline-playing');
        card.setAttribute('aria-pressed', 'false');
        return;
      }

      pauseInlineVideos(card);
      pauseModalVideos();
      card.classList.add('is-inline-playing');
      card.setAttribute('aria-pressed', 'true');
      video.controls = false;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');
      video.muted = mobileMediaQuery.matches;
      video.play().catch(function () {
        video.muted = true;
        video.setAttribute('muted', '');
        video.play().catch(function () {});
      });
    });

    function pruneDuplicateStrips() {
      toArray(root.querySelectorAll('.custom-judge__videos')).forEach(function (node) {
        if (node !== strip) node.remove();
      });
    }

    function markMountedState() {
      root.dataset.customJudgeMounted = strip.closest('[data-judgeme-product-reviews]') ? 'true' : 'false';
    }

    function stopMountRetries() {
      if (mountRetryTimeout) {
        window.clearTimeout(mountRetryTimeout);
        mountRetryTimeout = null;
      }
    }

    function setupMobileLoop() {
      if (teardownMobileLoop) {
        teardownMobileLoop();
        teardownMobileLoop = null;
      }

      strip.querySelectorAll('[data-custom-judge-clone="true"]').forEach(function (node) {
        node.remove();
      });

      if (!mobileMediaQuery.matches) {
        strip.scrollLeft = 0;
        return;
      }

      var originalCards = toArray(strip.querySelectorAll('[data-custom-judge-card]:not([data-custom-judge-clone])'));
      if (originalCards.length <= mobileCardsPerRow) return;

      syncAllCardModes();

      teardownMobileLoop = function () {
        strip.querySelectorAll('[data-custom-judge-clone="true"]').forEach(function (node) {
          node.remove();
        });
        if (!mobileMediaQuery.matches) {
          strip.scrollLeft = 0;
        }
      };
    }

    function ensureMountedStrip(targetParent, nextSibling) {
      if (!sourceStrip || !targetParent) return false;

      if (sourceStrip.parentElement !== targetParent || sourceStrip.nextSibling !== nextSibling) {
        targetParent.insertBefore(sourceStrip, nextSibling);
      }

      sourceStrip.style.display = 'flex';
      sourceStrip.style.width = '100%';
      sourceStrip.style.minWidth = '100%';
      sourceStrip.style.boxSizing = 'border-box';

      strip = sourceStrip;
      pruneDuplicateStrips();
      markMountedState();
      setupMobileLoop();
      syncAllCardModes();
      return true;
    }

    function mountVideos() {
      var reviewWidget = widget.querySelector('.jdgm-rev-widg');
      if (!reviewWidget) return { mounted: false, stable: false };

      var nativeMediaRow = reviewWidget.querySelector('.jdgm-row-media');
      var nativeGallery = reviewWidget.querySelector('.jdgm-gallery-wrapper');
      var actionsRow = reviewWidget.querySelector('.jdgm-row-actions');
      var body = reviewWidget.querySelector('.jdgm-rev-widg__body');
      var sortRow = reviewWidget.querySelector('.jdgm-rev-widg__sort-wrapper, .jdgm-sort-dropdown-wrapper, .jdgm-sort-dropdown, .jdgm-rev-widg__reviews-toolbar, .jdgm-widget-actions-and-sort');

      if (isDynamicVideoReviews && !syncDynamicJudgeCards(reviewWidget)) {
        markMountedState();
        return { mounted: false, stable: false };
      }

      if (nativeMediaRow) nativeMediaRow.style.display = 'none';
      if (nativeGallery) nativeGallery.style.display = 'none';

      if (actionsRow && actionsRow.parentElement) {
        return {
          mounted: ensureMountedStrip(actionsRow.parentElement, actionsRow),
          stable: true
        };
      }

      if (sortRow && sortRow.parentElement) {
        return {
          mounted: ensureMountedStrip(sortRow.parentElement, sortRow),
          stable: false
        };
      }

      if (body) {
        return {
          mounted: ensureMountedStrip(body, body.firstChild),
          stable: false
        };
      }

      if (nativeMediaRow && nativeMediaRow.parentElement) {
        return {
          mounted: ensureMountedStrip(nativeMediaRow.parentElement, nativeMediaRow),
          stable: false
        };
      }

      if (nativeGallery && nativeGallery.parentElement) {
        return {
          mounted: ensureMountedStrip(nativeGallery.parentElement, nativeGallery),
          stable: false
        };
      }

      markMountedState();
      return { mounted: false, stable: false };
    }

    function runMountPass() {
      var result = mountVideos();
      var dynamicCount = Number(sourceStrip.dataset.customJudgeDynamicCount || 0);
      var dynamicStillHydrating = isDynamicVideoReviews && dynamicCount > 0 && dynamicCount < 5;
      if ((result.stable || result.mounted) && !dynamicStillHydrating) {
        stopMountRetries();
      }
      return result;
    }

    var mountPassFrame = 0;
    var mountObserver = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        if (sourceStrip && sourceStrip.contains(mutation.target)) return false;
        return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
      });
      if (!shouldRun) return;

      if (mountPassFrame) cancelAnimationFrame(mountPassFrame);
      mountPassFrame = requestAnimationFrame(function () {
        mountPassFrame = 0;
        runMountPass();
      });
    });
    mountObserver.observe(widget, { childList: true, subtree: true });

    setupMobileLoop();
    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', function () {
        setupMobileLoop();
        syncAllCardModes();
        runMountPass();
      });
    } else if (typeof mobileMediaQuery.addListener === 'function') {
      mobileMediaQuery.addListener(function () {
        setupMobileLoop();
        syncAllCardModes();
        runMountPass();
      });
    }

    syncAllCardModes();

    function scheduleNextMountRetry() {
      var retryDelays = [250, 500, 1000, 2000, 4000, 8000];
      var retryIndex = 0;

      function runRetry() {
        if (retryIndex >= retryDelays.length) {
          stopMountRetries();
          return;
        }

        mountRetryTimeout = window.setTimeout(function () {
          mountRetryTimeout = null;
          var result = runMountPass();
          if (!result.stable && !result.mounted) {
            retryIndex += 1;
            runRetry();
          }
        }, retryDelays[retryIndex]);
      }

      runRetry();
    }

    var initialMount = runMountPass();
    if (!initialMount.stable) {
      scheduleNextMountRetry();
    }
  }

  function initCustomJudge(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (context.matches && context.matches('[data-custom-judge-root]')) {
      roots.push(context);
    }

    roots = roots.concat(toArray(context.querySelectorAll('[data-custom-judge-root]')));
    roots.forEach(initCustomJudgeRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCustomJudge(document);
    });
  } else {
    initCustomJudge(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCustomJudge(event.target || document);
  });
})();

// Stop PDP review videos as soon as their shared dialog starts closing.
(function () {
  function pauseSidebarVideoDialogVideos(dialog) {
    if (!dialog) return;

    Array.prototype.slice.call(dialog.querySelectorAll('video')).forEach(function (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (error) {}
    });
  }

  function bindSidebarVideoDialogDismissal(dialog) {
    if (!dialog || dialog.dataset.sidebarVideoDismissInit === 'true') return;

    dialog.dataset.sidebarVideoDismissInit = 'true';
    dialog.addEventListener('closing', function () {
      pauseSidebarVideoDialogVideos(dialog);
    });
  }

  function initSidebarVideoDialogDismissal(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var dialogs = [];

    if (context.matches && context.matches('.sidebar-video-dialog')) {
      dialogs.push(context);
    }

    dialogs = dialogs.concat(Array.prototype.slice.call(context.querySelectorAll('.sidebar-video-dialog')));
    dialogs.forEach(bindSidebarVideoDialogDismissal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSidebarVideoDialogDismissal(document);
    });
  } else {
    initSidebarVideoDialogDismissal(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSidebarVideoDialogDismissal(event.target || document);
  });
})();

(function () {
  var CART_V3_TARGET_HANDLES = {
    "8hours-daily-sleep-recovery-supplement": true,
    "8-hours-rise": true
  };
  var cartV3NormalizePromise = null;

  function getSectionIds(cartDrawer, cartNotification) {
    var sectionsToRender = [];

    if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
      sectionsToRender = sectionsToRender.concat(cartNotification.getSectionsToRender());
    }

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionsToRender = sectionsToRender.concat(cartDrawer.getSectionsToRender());
    }

    return sectionsToRender.map(function (section) {
      return section.id;
    });
  }

  function getCartV3JsonUrl() {
    var cartUrlBase = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return /\.js$/.test(cartUrlBase) ? cartUrlBase : cartUrlBase + '.js';
  }

  function getCartV3ChangeUrl() {
    var changeUrlBase = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';
    return /\.js$/.test(changeUrlBase) ? changeUrlBase : changeUrlBase + '.js';
  }

  var CART_V3_FALLBACK_UPSELL_IMAGES = {
    sleep: '//www.8-hours.com/cdn/shop/files/sleep_4d40c199-875a-4646-beee-98c1183744fd.webp?width=160',
    rise: '//www.8-hours.com/cdn/shop/files/rise_render_2_angle.png?width=160'
  };

  function getCartV3OverrideImageUrl(handle) {
    var images = window.__SHTCartV3UpsellImages || {};
    if (handle === '8hours-daily-sleep-recovery-supplement') return images.sleep || CART_V3_FALLBACK_UPSELL_IMAGES.sleep || '';
    if (handle === '8-hours-rise') return images.rise || CART_V3_FALLBACK_UPSELL_IMAGES.rise || '';
    return '';
  }

  function applyCartV3UpsellImageOverrides(root) {
    root = root && root.querySelectorAll ? root : document;

    root.querySelectorAll('.cart-drawer-v3__upsell[data-cart-v3-upsell-product]').forEach(function (upsell) {
      var handle = upsell.getAttribute('data-cart-v3-upsell-product') || '';
      var imageUrl = getCartV3OverrideImageUrl(handle);
      var media = upsell.querySelector('.cart-drawer-v3__upsell-media');
      var image = media && media.querySelector('.cart-drawer-v3__upsell-image');
      var title = upsell.querySelector('.cart-drawer-v3__upsell-title');

      if (!imageUrl || !media) return;

      if (!image) {
        image = document.createElement('img');
        image.className = 'cart-drawer-v3__upsell-image';
        image.loading = 'lazy';
        media.appendChild(image);
      }

      image.src = imageUrl;
      image.alt = title ? title.textContent.trim() : '';
      image.setAttribute('data-cart-v3-override-src', imageUrl);
      image.removeAttribute('srcset');
      image.removeAttribute('width');
      image.removeAttribute('height');
    });
  }

  function getCartV3ItemHandle(item) {
    if (!item || typeof item !== 'object') return '';
    if (item.handle) return String(item.handle);
    if (item.product_handle) return String(item.product_handle);
    if (item.url && item.url.indexOf('/products/') !== -1) {
      return String(item.url).split('/products/')[1].split('?')[0].split('/')[0];
    }
    return '';
  }

  function getCartV3SellingPlanKey(item) {
    var allocation = item && item.selling_plan_allocation;
    var sellingPlan = allocation && allocation.selling_plan;
    if (!sellingPlan) return '';
    return String(sellingPlan.id || sellingPlan.name || '');
  }

  function hasCartV3VisibleLineProperties(item) {
    var properties = (item && item.properties) || {};
    return Object.keys(properties).some(function (key) {
      return key.charAt(0) !== '_' && properties[key] !== null && properties[key] !== '';
    });
  }

  function getCartV3LineMergeKey(item) {
    var handle = getCartV3ItemHandle(item);
    var variantId = item && parseInt(item.variant_id || '', 10);
    var finalLinePrice = item && parseInt(item.final_line_price || '0', 10);
    if (!handle || !CART_V3_TARGET_HANDLES[handle]) return '';
    if (!Number.isFinite(variantId) || variantId <= 0) return '';
    if (!Number.isFinite(finalLinePrice) || finalLinePrice <= 0) return '';
    if (hasCartV3VisibleLineProperties(item)) return '';
    /* A bundle line belongs to its own bundle (_byob_id), and a Welcome Kit
       line carries the plan its gifts are for (_gift_plan): neither is a
       duplicate. Merging rewrites their keys under the open drawer, whose
       buttons then point at lines that no longer exist. */
    var hidden = (item && item.properties) || {};
    if (hidden._byob_id || hidden._gift_plan) return '';
    return [handle, variantId, getCartV3SellingPlanKey(item)].join('::');
  }

  function postCartV3Change(body) {
    return fetch(getCartV3ChangeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to normalize duplicate cart lines.');
      }
      return response.json();
    });
  }

  function renderCartV3SectionPayload(responseJson) {
    if (!responseJson || !responseJson.sections || typeof responseJson.sections !== 'object') return;

    var cartDrawer = document.querySelector('sht-cart-drwr');
    var cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
    var cartNotification = document.querySelector('sht-cart-noti');

    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(responseJson);
    }

    if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') {
      cartDrawerForm.renderContents(responseJson);
    }

    applyCartV3UpsellImageOverrides(document);

    if (cartDrawer && window.SHTSideCartV3 && typeof window.SHTSideCartV3.refresh === 'function') {
      window.SHTSideCartV3.refresh();
    }
  }

  function mergeCartV3DuplicateGroup(group, includeSections) {
    var totalQuantity = group.reduce(function (sum, item) {
      var quantity = parseInt(item.quantity || '0', 10);
      return sum + (Number.isFinite(quantity) && quantity > 0 ? quantity : 0);
    }, 0);
    var survivor = group.find(function (item) {
      return !item.properties || !Object.keys(item.properties).length;
    }) || group[0];
    var removals = group.filter(function (item) {
      return item.key && item.key !== survivor.key;
    });

    return removals.reduce(function (promise, item) {
      return promise.then(function () {
        return postCartV3Change({ id: item.key, quantity: 0 });
      });
    }, Promise.resolve()).then(function () {
      var body = {
        id: survivor.key,
        quantity: totalQuantity,
        properties: {}
      };
      if (includeSections) {
        var cartDrawer = document.querySelector('sht-cart-drwr');
        var cartNotification = document.querySelector('sht-cart-noti');
        body.sections = getSectionIds(cartDrawer, cartNotification);
        body.sections_url = window.location.pathname;
      }
      return postCartV3Change(body);
    });
  }

  function normalizeCartV3DuplicateTargetLines() {
    var cartDrawer = document.querySelector('sht-cart-drwr');
    if (!cartDrawer || cartDrawer.getAttribute('data-side-cart-v3-active') !== 'true') {
      return Promise.resolve(false);
    }
    if (cartV3NormalizePromise) return cartV3NormalizePromise;

    cartV3NormalizePromise = fetch(getCartV3JsonUrl(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to fetch cart for duplicate normalization.');
        }
        return response.json();
      })
      .then(function (cart) {
        var groupsByKey = {};
        if (!cart || !Array.isArray(cart.items)) return [];

        cart.items.forEach(function (item) {
          var key = getCartV3LineMergeKey(item);
          if (!key) return;
          if (!groupsByKey[key]) groupsByKey[key] = [];
          groupsByKey[key].push(item);
        });

        return Object.keys(groupsByKey).map(function (key) {
          return groupsByKey[key];
        }).filter(function (group) {
          return group.length > 1;
        });
      })
      .then(function (groups) {
        var latestPayload = null;
        if (!groups.length) return false;

        return groups.reduce(function (promise, group, index) {
          return promise.then(function () {
            return mergeCartV3DuplicateGroup(group, index === groups.length - 1).then(function (payload) {
              latestPayload = payload;
            });
          });
        }, Promise.resolve()).then(function () {
          renderCartV3SectionPayload(latestPayload);
          return true;
        });
      })
      .catch(function (error) {
        console.warn('Cart v3 duplicate line normalization failed', error);
        return false;
      })
      .finally(function () {
        cartV3NormalizePromise = null;
      });

    return cartV3NormalizePromise;
  }

  function bindCartV3DuplicateNormalization() {
    var cartDrawer = document.querySelector('sht-cart-drwr');
    if (!cartDrawer || cartDrawer.dataset.cartV3DuplicateNormalizeBound === 'true') return;
    cartDrawer.dataset.cartV3DuplicateNormalizeBound = 'true';
    cartDrawer.addEventListener('opened', normalizeCartV3DuplicateTargetLines);
  }

  function initCartV3Enhancements(root) {
    bindCartV3DuplicateNormalization();
    applyCartV3UpsellImageOverrides(root || document);
  }

  function setLoading(submitButton, loading) {
    if (!submitButton) return;
    submitButton.classList.toggle('loading', loading);
    if (loading) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.setAttribute('disabled', 'disabled');
    } else {
      submitButton.removeAttribute('aria-disabled');
      submitButton.removeAttribute('disabled');
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('.js-cart-v3-upsell-form') : null;
    if (!form) return;

    event.preventDefault();

    var submitButton = form.querySelector('.js-cart-v3-upsell-submit');
    if (submitButton && submitButton.classList.contains('loading')) return;

    var cartDrawer = document.querySelector('sht-cart-drwr');
    var cartDrawerForm = document.querySelector('sht-cart-drwr-frm');
    var cartNotification = document.querySelector('sht-cart-noti');
    var formData = new FormData(form);
    var sectionIds = getSectionIds(cartDrawer, cartNotification);

    if (sectionIds.length) formData.append('sections', sectionIds);
    formData.append('sections_url', window.location.pathname);

    var cfg = (window.SHTHelper && window.SHTHelper.fetchConfigHTTP) ? window.SHTHelper.fetchConfigHTTP : { method: 'POST' };
    cfg = Object.assign({}, cfg, { body: formData });

    setLoading(submitButton, true);

    fetch('' + (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'), cfg)
      .then(function (response) {
        return response.json().then(function (responseJson) {
          if (!response.ok || responseJson.status) {
            throw new Error(responseJson.description || responseJson.message || 'Unable to add cart upsell.');
          }
          return responseJson;
        });
      })
      .then(function (responseJson) {
        if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(responseJson);
        }

        if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') {
          cartDrawerForm.renderContents(responseJson);
        }

        applyCartV3UpsellImageOverrides(document);

        if (window.SHTSideCartV3 && typeof window.SHTSideCartV3.refresh === 'function') {
          window.setTimeout(function () {
            window.SHTSideCartV3.refresh();
          }, 0);
        }

        if (cartDrawer && typeof cartDrawer.openDrawer === 'function') {
          cartDrawer.openDrawer(document.querySelector('.js-header-cart-status-btn') || submitButton);
        }

        normalizeCartV3DuplicateTargetLines();
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        setLoading(submitButton, false);
      });
  }, true);

  window.SHTCartV3NormalizeDuplicateLines = normalizeCartV3DuplicateTargetLines;
  window.SHTCartV3ApplyUpsellImageOverrides = applyCartV3UpsellImageOverrides;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCartV3Enhancements(document);
    });
  } else {
    initCartV3Enhancements(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initCartV3Enhancements(event.target || document);
  });
})();

// Remove legacy Ka-ching app embed from PDP; custom AM/PM widget replaces it.
(function () {
    if (!document.body || !document.body.classList.contains('template-product')) {
        return;
    }

    function hideLegacy(root) {
        root = root && root.querySelector ? root : document;
        var bundles = root.querySelectorAll('kaching-bundle');
        if (!bundles.length) return false;
        bundles.forEach(function (bundle) {
            if (bundle.parentNode) {
                bundle.parentNode.removeChild(bundle);
            }
        });
        return true;
    }

    function init(root) {
        if (hideLegacy(root)) return;
        var obs = new MutationObserver(function () {
            if (hideLegacy(root)) obs.disconnect();
        });
        obs.observe(document.documentElement, { childList: true, subtree: true });
        window.setTimeout(function () { obs.disconnect(); }, 8000);
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
})();

// AM/PM custom bundle add-to-cart: submit two items through existing AJAX cart flow.
(function () {
    function getCustomAmpmBundleState(root, form) {
        root = root || document;
        var scopedWrapper = null;

        if (form && form.closest) {
            scopedWrapper = form.closest('.custom_boc_subscripe_full');
            if (scopedWrapper) {
                if (scopedWrapper.getAttribute('data-hide-bundle-step') === 'true') {
                    return null;
                }

                root = scopedWrapper;
                var scopedHeading = scopedWrapper.querySelector('.custom_widget_subscription_heading_item.active[data_tab="3"]');
                var scopedSelectedTab = getSelectedPurchaseTab(jQuery(scopedWrapper), jQuery(scopedWrapper));
                var scopedAmpmSelected = scopedWrapper.classList.contains('is-v2-ampm-active') || !!scopedHeading;

                if (!scopedAmpmSelected) {
                    return null;
                }

                if (scopedSelectedTab === '3') {
                    scopedSelectedTab = '1';
                }

                if (scopedSelectedTab !== '1' && scopedSelectedTab !== '2' && !scopedHeading) {
                    return null;
                }
            }
        }

        var activeHeading = root.querySelector('.custom_widget_subscription_heading_item.active[data_tab="3"]');
        var wrapper = scopedWrapper || (activeHeading ? activeHeading.closest('.custom_boc_subscripe_full') : root.querySelector('.custom_boc_subscripe_full'));
        if (!wrapper) return null;
        if (wrapper.getAttribute('data-hide-bundle-step') === 'true') return null;

        var selectedPurchaseTab = getSelectedPurchaseTab(jQuery(wrapper), jQuery(wrapper));
        var isAmpmSelected = wrapper.classList.contains('is-v2-ampm-active') || !!activeHeading;
        if (!isAmpmSelected) return null;
        if (selectedPurchaseTab === '3') selectedPurchaseTab = '1';

        var select = wrapper.querySelector('.js-ampm-bundle-interval');
        if (!select || !select.options || select.selectedIndex < 0) return null;

        var option = select.options[select.selectedIndex];
        var mainVariantId = parseInt(option.getAttribute('data-main-variant-id') || '', 10);
        var otherVariantId = parseInt(option.getAttribute('data-other-variant-id') || '', 10);
        if (!Number.isFinite(mainVariantId) || !Number.isFinite(otherVariantId)) return null;

        var mainSellingPlanId = parseInt(option.getAttribute('data-main-selling-plan-id') || '', 10);
        if (!Number.isFinite(mainSellingPlanId)) mainSellingPlanId = null;
        var otherSellingPlanId = parseInt(option.getAttribute('data-other-selling-plan-id') || '', 10);
        if (!Number.isFinite(otherSellingPlanId)) otherSellingPlanId = null;

        if (selectedPurchaseTab === '2') {
            mainSellingPlanId = null;
            otherSellingPlanId = null;
        }

        return {
            currentVariantId: mainVariantId,
            otherVariantId: otherVariantId,
            mainSellingPlanId: mainSellingPlanId,
            otherSellingPlanId: otherSellingPlanId,
            selectedPurchaseTab: selectedPurchaseTab,
        };
    }

    function isAmpmBundleCartLine(item) {
        if (!item || typeof item !== 'object') return false;
        var properties = item.properties || {};
        var marker = properties._ampm_bundle;
        if (marker === true) return true;
        if (typeof marker === 'string') {
            var normalized = marker.trim().toLowerCase();
            return normalized === 'true' || normalized === '1' || normalized === 'yes';
        }
        return false;
    }

    function purgeSingleCartLinesForBundle(bundleState) {
        if (!bundleState) return Promise.resolve();

        var variantIds = [parseInt(bundleState.currentVariantId || '', 10), parseInt(bundleState.otherVariantId || '', 10)].filter(function (id) {
            return Number.isFinite(id) && id > 0;
        });
        if (!variantIds.length) {
            return Promise.resolve();
        }

        var variantIdMap = {};
        variantIds.forEach(function (id) { variantIdMap[id] = true; });

        var cartUrlBase = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        var cartUrl = /\.js$/.test(cartUrlBase) ? cartUrlBase : cartUrlBase + '.js';
        var cartChangeUrlBase = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';
        var cartChangeUrl = /\.js$/.test(cartChangeUrlBase) ? cartChangeUrlBase : cartChangeUrlBase + '.js';

        return fetch(cartUrl, { credentials: 'same-origin' })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Failed to fetch cart state');
                }
                return response.json();
            })
            .then(function (cart) {
                if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
                    return [];
                }

                var lineKeysToRemove = [];
                cart.items.forEach(function (item) {
                    var variantId = parseInt(item.variant_id || '', 10);
                    if (!Number.isFinite(variantId) || !variantIdMap[variantId]) {
                        return;
                    }
                    if (isAmpmBundleCartLine(item)) {
                        return;
                    }
                    if (item.key) {
                        lineKeysToRemove.push(String(item.key));
                    }
                });
                return lineKeysToRemove;
            })
            .then(function (lineKeysToRemove) {
                if (!lineKeysToRemove || !lineKeysToRemove.length) {
                    return;
                }

                var removeRequests = lineKeysToRemove.map(function (lineKey) {
                    return fetch(cartChangeUrl, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            id: lineKey,
                            quantity: 0
                        })
                    }).then(function (response) {
                        if (!response.ok) {
                            throw new Error('Failed to remove single-product line');
                        }
                        return response.json();
                    });
                });

                return Promise.all(removeRequests);
            })
            .catch(function (error) {
                // Best-effort clean-up; if it fails we still proceed with the add flow.
                console.warn('AM/PM pre-add cart clean-up failed', error);
            });
    }

    function submitBundleAdd(host, form, bundleState) {
        if (!host || !form || !bundleState) return;
        if (host.elms && host.elms.submit_btn && host.elms.submit_btn.classList.contains('loading')) return;

        if (host.handleErrorMessage) host.handleErrorMessage();
        if (host.elms && host.elms.submit_btn) {
            host.elms.submit_btn.setAttribute('aria-disabled', true);
            host.elms.submit_btn.classList.add('loading');
        }
        if (host.elms && host.elms.spinner) host.elms.spinner.classList.remove('hidden');

        var sectionsToRender = [];
        if (host.cartNotification && host.cartNotification.getSectionsToRender) {
            sectionsToRender = host.cartNotification.getSectionsToRender();
        }
        if (host.cartDrawer && host.cartDrawer.getSectionsToRender) {
            sectionsToRender = sectionsToRender.concat(host.cartDrawer.getSectionsToRender());
        }

        var formData = new FormData(form);
        var qty = parseInt(formData.get('quantity') || '1', 10);
        if (!Number.isFinite(qty) || qty <= 0) qty = 1;

        var mainVariantId = bundleState.currentVariantId || parseInt(formData.get('id') || '', 10);
        var otherVariantId = bundleState.otherVariantId;
        if (!mainVariantId || !otherVariantId) {
            if (host.elms && host.elms.submit_btn) {
                host.elms.submit_btn.classList.remove('loading');
                host.elms.submit_btn.removeAttribute('aria-disabled');
            }
            if (host.elms && host.elms.spinner) host.elms.spinner.classList.add('hidden');
            return;
        }

        var sellingPlanId = bundleState.mainSellingPlanId || formData.get('selling_plan');
        var isSubscription = !!sellingPlanId;

        formData.delete('id');
        formData.delete('quantity');
        formData.delete('selling_plan');
        formData.delete('properties[__kaching_bundles]');

        formData.append('items[0][id]', String(mainVariantId));
        formData.append('items[0][quantity]', String(qty));
        if (isSubscription) {
            formData.append('items[0][selling_plan]', String(sellingPlanId));
        }
        formData.append('items[0][properties][_ampm_bundle]', 'true');
        formData.append('items[0][properties][_ampm_bundle_role]', 'main');

        formData.append('items[1][id]', String(otherVariantId));
        formData.append('items[1][quantity]', String(qty));
        if (bundleState.otherSellingPlanId) {
            formData.append('items[1][selling_plan]', String(bundleState.otherSellingPlanId));
        }
        formData.append('items[1][properties][_ampm_bundle]', 'true');
        formData.append('items[1][properties][_ampm_bundle_role]', 'other');

        if (sectionsToRender.length) formData.append('sections', sectionsToRender.map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);

        var cfg = (window.SHTHelper && window.SHTHelper.fetchConfigHTTP) ? window.SHTHelper.fetchConfigHTTP : { method: 'POST' };
        cfg = Object.assign({}, cfg, { body: formData });

        function closeBogosPopup() {
            var closeSelectors = [
                '.bogos-slider-close-btn',
                '#freegifts-main-popup-container .bogos-slider-close-btn',
                '.bogos-shopify-block .bogos-slider-close-btn',
                '.bogos-shopify-block [class*="close"]'
            ];
            closeSelectors.forEach(function (selector) {
                var btn = document.querySelector(selector);
                if (btn) {
                    try { btn.click(); } catch (e) {}
                }
            });

            var containers = document.querySelectorAll(
                '#freegifts-main-popup-container, .bogos-shopify-block, .bogos-gift-slider, .bogos-gift-popup'
            );
            containers.forEach(function (container) {
                if (!container) return;
                container.classList.remove('sca-is-visible-fg');
                container.setAttribute('aria-hidden', 'true');
                if (container.id === 'freegifts-main-popup-container') {
                    container.style.display = 'none';
                }
            });
        }

        purgeSingleCartLinesForBundle(bundleState)
            .then(function () {
                return fetch('' + (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'), cfg);
            })
            .then(function (r) {
                if (!r.ok) {
                    return r.text().then(function (text) {
                        var msg;
                        try {
                            var parsed = JSON.parse(text);
                            msg = parsed.description || parsed.message || ('HTTP ' + r.status);
                        } catch (_) {
                            msg = 'HTTP ' + r.status + ' ' + r.statusText;
                        }
                        var err = new Error(msg);
                        err.cartAddFailed = true;
                        throw err;
                    });
                }
                return r.json();
            })
            .then(function (t) {
                if (t && t.status) {
                    if (host.handleErrorMessage) host.handleErrorMessage(t.description);
                    return;
                }

                if (host.elms && host.elms.sticky_header && host.elms.sticky_header.dataset.isEnabled && host.elms.sticky_header.reveal) {
                    host.elms.sticky_header.reveal();
                }

                var hasSectionsPayload = !!(t && t.sections && typeof t.sections === 'object');
                if (hasSectionsPayload && host.cartNotification && host.cartNotification.renderContents) {
                    try { host.cartNotification.renderContents(t); } catch (e) {}
                }
                if (hasSectionsPayload && host.cartDrawerForm && host.cartDrawerForm.renderContents) {
                    try { host.cartDrawerForm.renderContents(t); } catch (e) {}
                }

                window.setTimeout(function () {
                    var opener =
                        (window.SHTHelper && window.SHTHelper.qs && window.SHTHelper.qs('.js-header-cart-status-btn')) ||
                        (host.elms && host.elms.submit_btn);
                    var drawer = host.cartDrawer || document.querySelector('sht-cart-drwr');

                    var attempts = 0;
                    var interval = window.setInterval(function () {
                        attempts += 1;
                        closeBogosPopup();

                        try {
                            if (drawer && drawer.openDrawer) drawer.openDrawer(opener);
                        } catch (e) {}

                        if (attempts >= 6) window.clearInterval(interval);
                    }, 200);
                }, 50);
            })
            .catch(function (err) {
                if (err && err.cartAddFailed && host.handleErrorMessage) {
                    host.handleErrorMessage(err.message);
                } else {
                    console.error(err);
                }
            })
            .finally(function () {
                if (host.elms && host.elms.submit_btn) {
                    host.elms.submit_btn.classList.remove('loading');
                    host.elms.submit_btn.removeAttribute('aria-disabled');
                }
                if (host.elms && host.elms.spinner) host.elms.spinner.classList.add('hidden');
            });
    }

    document.addEventListener('submit', function (e) {
        try {
            var form = e.target;
            if (!form || form.tagName !== 'FORM') return;
            if (!form.closest('.custom_product_add_to_carts_main')) return;

            var host = form.closest('sht-prd-frm');
            if (!host && form.closest('.atc-sub-v9')) {
                var cartDrawer = document.getElementById('shtCartDrawer');
                host = {
                    elms: {
                        submit_btn: form.querySelector('.js-product-form-submit-btn'),
                        spinner: form.querySelector('.js-product-form-spinner')
                    },
                    cartDrawer: cartDrawer,
                    cartDrawerForm: cartDrawer ? cartDrawer.querySelector('sht-cart-drwr-frm') : null
                };
            }
            if (!host) return;

            var root = (host.closest && host.closest('.shopify-section')) || document;
            var bundleState = getCustomAmpmBundleState(root, form);
            if (!bundleState) return;

            e.preventDefault();
            e.stopImmediatePropagation();
            submitBundleAdd(host, form, bundleState);
        } catch (err) {}
    }, true);
})();



// Sync subscription benefits with the currently selected variant.
jQuery(document).on('change', '.js-variant-radio-item, .js-variant-select-item', function () {
    var form = jQuery(this).closest('form');
    var variantId = form.find('[name="id"]').val();
    if (!variantId) {
        return;
    }
    var wrapper = form.closest('.custom_boc_subscripe_full');
    if (!wrapper.length) {
        return;
    }
    var subscriptionCard = wrapper.find('.custom_widget_subscription');
    if (!subscriptionCard.length) return;
    var matchingTab = subscriptionCard.find('.subscription_heading_member_item[variant_id="' + variantId + '"]');
    if (matchingTab.length) {
        matchingTab.first().trigger('click');
    }
});

jQuery(document).on('click', 'span.subscription_heading_member_item', function () {
    var item = jQuery(this);
    var current_tab = item.attr('data_tab');
    var subscriptionCard = item.closest('.custom_widget_subscription');
    var wrapper = item.closest('.custom_boc_subscripe_full');
    var isV9PlainQuantity = isAtcSubV9PlainQuantity(wrapper);
    var isV9OneTimeDurationItem = item.hasClass('subscription_heading_member_item--v9-otp');
    var scopedForm = wrapper.find('.custom_product_add_to_carts_main form').first();

    if (subscriptionCard.length) {
        subscriptionCard.find('span.subscription_heading_member_item').removeClass('active');
        subscriptionCard.find('.subscription_heading_member_item[data_tab="' + current_tab + '"]').addClass('active');
        subscriptionCard.find('.subscription_heading_member_content').hide();
        subscriptionCard.find('.subscription_heading_member_content[data_tab="' + current_tab + '"]').show();
        subscriptionCard.find('.subscription_prices_item').removeClass('active');
        subscriptionCard.find('.subscription_prices_item[data_tab="' + current_tab + '"]').addClass('active');
        subscriptionCard.find('.subscription_prices_item').hide();
        subscriptionCard.find('.subscription_prices_item[data_tab="' + current_tab + '"]').show();
        subscriptionCard.find('.single_price_item').removeClass('active');
        subscriptionCard.find('.single_price_item[data_tab="' + current_tab + '"]').addClass('active');
        subscriptionCard.find('.single_price_item').hide();
        subscriptionCard.find('.single_price_item[data_tab="' + current_tab + '"]').show();
    } else if (wrapper.length && isV9OneTimeDurationItem) {
        wrapper.find('.custom_widget_subscription_content--v9-one-time .subscription_heading_member_item--v9-otp').removeClass('active');
        item.addClass('active');
        wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item').removeClass('active');
        wrapper.find('.custom_widget_subscription_content[data_tab="1"] .subscription_heading_member.months .subscription_heading_member_item[data_tab="' + current_tab + '"]').addClass('active');
    }
    toggleAtcSubV2TextContent(wrapper, current_tab);

    var selling_plan = isV9PlainQuantity ? '' : item.attr('selling_plan');
    var variant_id = item.attr('variant_id');
    if (subscriptionCard.length) {
        subscriptionCard.find('.custom_widget_subscription_heading_item[data_tab="1"]').attr('variant_id', variant_id);
        subscriptionCard.find('.custom_widget_subscription_heading_item[data_tab="1"]').attr('selling_plan', selling_plan);
    } else if (wrapper.length && isV9OneTimeDurationItem) {
        wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').attr('variant_id', variant_id);
        wrapper.find('.custom_widget_subscription .custom_widget_subscription_heading_item[data_tab="1"]').attr('selling_plan', selling_plan);
    }
    if (scopedForm.length) {
        scopedForm.find('[name="id"]').val(variant_id);
        if (isV9PlainQuantity) {
            scopedForm.find('[name="selling_plan"]').attr('disabled', 'disabled').val('');
        } else {
            scopedForm.find('[name="selling_plan"]').removeAttr('disabled');
            scopedForm.find('[name="selling_plan"]').val(selling_plan);
        }
    }

    syncAtcSubV2BundleIntervals(wrapper, current_tab, false);

    syncAtcSubV9OneTimeState(wrapper);
    applyAtcSubPackFrequencyCopy(wrapper);
    updateAtcSubV2SubscribeLabel(wrapper);
    syncStickyAtcV2Card(wrapper);
    syncAmpmMobileStickyCartPrice(wrapper);
});

$(document).on("click", ".header__icons.header__icons--right .btn-icon.btn-search", function (e) {
    var openDrawer = document.querySelector('.header-v2__drawer.is-open');
    if (openDrawer) {
        var drawerClose = openDrawer.querySelector('[data-header-drawer-close]');
        if (drawerClose) {
            drawerClose.click();
        } else {
            openDrawer.classList.remove('is-open');
            openDrawer.hidden = true;
            document.body.classList.remove('header-v2--drawer-open');
        }
    } else if (document.body.classList.contains('header-v2--drawer-open')) {
        document.body.classList.remove('header-v2--drawer-open');
    }
    jQuery('sht-header').addClass('header--predictive-search-open');
    document.body.classList.add('search-open');
});

$(document).on("click", ".js-drawer-search-trigger", function (e) {
    e.preventDefault();
    var trigger = e.currentTarget;
    var openDrawer = document.querySelector('.header-v2__drawer.is-open');
    if (openDrawer) {
        var drawerClose = openDrawer.querySelector('[data-header-drawer-close]');
        if (drawerClose) {
            drawerClose.click();
        } else {
            openDrawer.classList.remove('is-open');
            openDrawer.hidden = true;
            document.body.classList.remove('header-v2--drawer-open');
        }
    } else if (document.body.classList.contains('header-v2--drawer-open')) {
        document.body.classList.remove('header-v2--drawer-open');
    }

    if (!window.SHTHelper) {
        return;
    }
    var header = document.querySelector('sht-header');
    if (!header) {
        return;
    }
    var predictiveSearchElm = header.querySelector('.js-predictive-search');
    var predictiveSearchInputElm = header.querySelector('.js-predictive-search-input');
    window.SHTHelper.loadScript(
        trigger.dataset.jsFileId,
        trigger.dataset.jsFile,
        function () {
            header.classList.add('header--predictive-search-open');
            document.body.classList.add('o-hidden');
            document.body.classList.add('search-open');
            setTimeout(function () {
                if (predictiveSearchElm && predictiveSearchInputElm) {
                    window.SHTHelper.trapFocus(predictiveSearchElm, predictiveSearchInputElm);
                }
            }, 650);
        }
    );
});

// Format Judge.me average text like "4.75 out of 5" -> "4.75/5"
// and optionally prepend rating + count in PDP badge text.
(function () {
    if (!document.body) {
        return;
    }

    var isProductTemplate = document.body.classList.contains('template-product');
    var hasJudgeElements =
        document.querySelector('.product__judgeme') ||
        document.querySelector('[data-judgeme-product-reviews]') ||
        document.querySelector('.jdgm-rev-widg');
    if (!isProductTemplate && !hasJudgeElements) {
        return;
    }

    function updateJudgeMeAverage(root) {
        var scope = root || document;
        var averageLinks = scope.querySelectorAll(
            '.jdgm-rev-widg__summary-average, .jdgm-rev-widg__summary-average a, .jdgm-prev-badge__text'
        );
        if (!averageLinks.length) {
            return;
        }
        averageLinks.forEach(function (el) {
            var text = el.textContent || '';
            if (text.indexOf(' out of ') === -1) {
                return;
            }
            el.textContent = text.replace(/\s*out of\s*/i, '/');
        });
    }

    function updateJudgeMeBadgeText(root) {
        var scope = root || document;
        var badgeBlocks = scope.querySelectorAll(
            '.product__judgeme[data-judgeme-show-rating-with-count="true"] .jdgm-prev-badge'
        );
        if (!badgeBlocks.length) {
            return;
        }
        badgeBlocks.forEach(function (badge) {
            var rating = badge.getAttribute('data-average-rating');
            var count = badge.getAttribute('data-number-of-reviews');
            if (!rating || !count) {
                return;
            }
            var ratingValue = parseFloat(rating);
            if (Number.isNaN(ratingValue)) {
                return;
            }
            var container = badge.closest('.product__judgeme');
            var separator = container && container.getAttribute('data-judgeme-separator') ? container.getAttribute('data-judgeme-separator') : ' ∙ ';
            if (!separator) {
                separator = ' ∙ ';
            }
            var textTarget = badge.querySelector('.jdgm-prev-badge__text');
            if (!textTarget) {
                return;
            }
            var displayRating = ratingValue.toFixed(1);
            var nextText = displayRating + '/5' + separator + count + ' reviews';
            if (textTarget.textContent !== nextText) {
                textTarget.textContent = nextText;
            }
        });
    }

    var pendingBadgeUpdate = false;
    function scheduleJudgeMeBadgeTextUpdate(root) {
        var scope = root || document;
        if (pendingBadgeUpdate) {
            return;
        }
        pendingBadgeUpdate = true;
        requestAnimationFrame(function () {
            pendingBadgeUpdate = false;
            updateJudgeMeAverage(scope);
            updateJudgeMeBadgeText(scope);
        });
    }

    function nodeContainsJudgeMe(node) {
        if (!node || node.nodeType !== 1) {
            return false;
        }
        if (
            node.matches &&
            node.matches('.product__judgeme, [data-judgeme-product-reviews], .jdgm-rev-widg, .jdgm-prev-badge')
        ) {
            return true;
        }
        return !!(
            node.querySelector &&
            node.querySelector('.product__judgeme, [data-judgeme-product-reviews], .jdgm-rev-widg, .jdgm-prev-badge')
        );
    }

    function scheduleJudgeMeRetries() {
        var retryDelays = [700, 1400, 2600, 4200, 6200];
        retryDelays.forEach(function (delay) {
            setTimeout(function () {
                scheduleJudgeMeBadgeTextUpdate(document);
            }, delay);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        scheduleJudgeMeBadgeTextUpdate(document);
        window.addEventListener('load', function () {
            scheduleJudgeMeBadgeTextUpdate(document);
        });
        scheduleJudgeMeRetries();

        if (typeof MutationObserver === 'undefined' || !document.body) {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            var shouldRefresh = false;
            mutations.forEach(function (mutation) {
                if (shouldRefresh || mutation.type !== 'childList' || !mutation.addedNodes.length) {
                    return;
                }
                mutation.addedNodes.forEach(function (node) {
                    if (!shouldRefresh && nodeContainsJudgeMe(node)) {
                        shouldRefresh = true;
                    }
                });
            });

            if (shouldRefresh) {
                scheduleJudgeMeBadgeTextUpdate(document);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // JudgeMe widgets settle within the 700/1400/2600/4200/6200 ms retry
        // window. After ~8s the body-wide observer is mostly noise (every cart
        // drawer / popup / third-party mutation fires the callback), so
        // disconnect to free background work for the rest of the session.
        window.setTimeout(function () { observer.disconnect(); }, 8000);
    });
})();

$(document).on("click", ".js-predictive-search-close-trigger", function (e) {
    jQuery('sht-header').removeClass('header--predictive-search-open');
    document.body.classList.remove('search-open');
});

(function () {
    function getHeader() {
        return document.querySelector('sht-header');
    }

    function getPredictive() {
        return document.querySelector('sht-predictive-srch');
    }

    function getSetting(name, fallback) {
        var header = getHeader();
        if (!header) {
            return fallback;
        }
        var value = header.dataset[name];
        if (value === undefined || value === "") {
            return fallback;
        }
        return value !== "false";
    }

    function isSearchOpen() {
        var header = getHeader();
        var predictive = getPredictive();
        return (
            (header && header.classList.contains('header--predictive-search-open')) ||
            (predictive && predictive.hasAttribute('open'))
        );
    }

    function isMobileViewport() {
        return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
    }

    function shouldCloseOnScroll() {
        var closeOnScroll = getSetting('searchCloseOnScroll', true);
        if (!closeOnScroll) {
            return false;
        }
        if (isMobileViewport()) {
            return false;
        }
        return true;
    }

    function closeSearch() {
        var header = getHeader();
        var predictive = getPredictive();
        if (predictive && typeof predictive.closeSearchResults === 'function') {
            predictive.closeSearchResults(true);
        }
        if (predictive) {
            predictive.removeAttribute('open');
        }
        if (header) {
            header.classList.remove('header--predictive-search-open');
        }
        document.body.classList.remove('o-hidden');
        document.body.classList.remove('search-open');
    }

    function applyScrollBehavior() {
        var allowScroll = getSetting('searchAllowScroll', true);
        if (isSearchOpen() && allowScroll) {
            document.body.classList.remove('o-hidden');
        }
        if (isSearchOpen()) {
            document.body.classList.add('search-open');
        }
    }

    var predictive = getPredictive();
    if (predictive) {
        var predictiveObserver = new MutationObserver(function () {
            applyScrollBehavior();
        });
        predictiveObserver.observe(predictive, { attributes: true, attributeFilter: ['open'] });
    }

    var header = getHeader();
    if (header) {
        var headerObserver = new MutationObserver(function () {
            if (!shouldCloseOnScroll()) {
                return;
            }
            if (header.classList.contains('is-header-hide') && isSearchOpen()) {
                closeSearch();
            }
        });
        headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    var scrollFrame = null;
    jQuery(window).on("scroll", function () {
        if (scrollFrame !== null) return;
        scrollFrame = window.requestAnimationFrame(function () {
            scrollFrame = null;
            if (!shouldCloseOnScroll()) return;
            if (isSearchOpen()) {
                closeSearch();
            }
        });
    });
})();

$(document).on("click", "a.button_member.product_member_button", function (e) {
    e.preventDefault();
    $('.custom_widget_subscription_heading_item[data_tab="1"]').trigger('click');
    $('.subscription_heading_member_item[data_tab="1"]').trigger('click');
    $('.custom_product_add_to_carts_main button.js-product-form-submit-btn').trigger('click');
});

(function () {
    var accountSubscriptionsPath = '/a/account/subscriptions';
    if (window.location.pathname.indexOf(accountSubscriptionsPath) !== 0) {
        return;
    }

    var upgradeLabel = 'Upgrade Subscription';
    var emailRecipient = 'letschat@8-hours.com';
    var emailSubject = encodeURIComponent('Subscription Upgrade');
    var emailBody = encodeURIComponent(
        'Hey 8hours team, I am looking to upgrade my subscription volume/frequency to get the best price & added convenience - what are my options?'
    );
    var mailtoHref = 'mailto:' + emailRecipient + '?subject=' + emailSubject + '&body=' + emailBody;
    var observer = null;

  function ensureOverlay(row) {
    if (!row) {
      return false;
    }

    var existingOverlay = row.querySelector('a.skio-upgrade-overlay');

    function triggerMailto(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      console.log('[skio-upgrade] triggerMailto start');
      var opened = false;

      try {
        window.location.href = mailtoHref;
        opened = true;
        console.log('[skio-upgrade] window.location href navigation attempted');
      } catch (error) {
        console.warn('[skio-upgrade] window.location href failed', error);
      }

      if (!opened) {
        try {
          window.location.assign(mailtoHref);
          opened = true;
          console.log('[skio-upgrade] window.location assign attempted');
        } catch (error) {
          console.warn('[skio-upgrade] window.location assign failed', error);
        }
      }

      if (!opened) {
        try {
          var tempLink = document.createElement('a');
          tempLink.href = mailtoHref;
          tempLink.target = '_top';
          tempLink.rel = 'noopener';
          tempLink.style.display = 'none';
          document.body.appendChild(tempLink);
          tempLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          tempLink.remove();
          opened = true;
          console.log('[skio-upgrade] temp anchor dispatched');
        } catch (error) {
          console.warn('[skio-upgrade] temp anchor dispatch failed', error);
        }
      }

      if (!opened) {
        try {
          var iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '1px';
          iframe.style.height = '1px';
          iframe.style.opacity = '0';
          iframe.style.pointerEvents = 'none';
          iframe.src = mailtoHref;
          document.body.appendChild(iframe);
          setTimeout(function () {
            iframe.remove();
          }, 2000);
          opened = true;
          console.log('[skio-upgrade] iframe fallback attempted');
        } catch (error) {
          console.error('[skio-upgrade] iframe fallback failed', error);
        }
      }
    }

    if (existingOverlay) {
      existingOverlay.setAttribute('href', mailtoHref);
      existingOverlay.setAttribute('aria-label', upgradeLabel);
      existingOverlay.setAttribute('title', upgradeLabel);
      existingOverlay.setAttribute('target', '_top');
      existingOverlay.setAttribute('rel', 'noopener');
      existingOverlay.removeEventListener('click', triggerMailto);
      existingOverlay.addEventListener('click', triggerMailto);
      return true;
    }

    var currentPosition = window.getComputedStyle(row).position;
    if (currentPosition === 'static' || !currentPosition) {
      row.style.position = 'relative';
    }

    var overlay = document.createElement('a');
    overlay.className = 'skio-upgrade-overlay';
    overlay.href = mailtoHref;
    overlay.target = '_top';
    overlay.rel = 'noopener';
    overlay.setAttribute('aria-label', upgradeLabel);
    overlay.setAttribute('title', upgradeLabel);
    overlay.style.position = 'absolute';
    overlay.style.inset = '0';
    overlay.style.zIndex = '10';
    overlay.style.borderRadius = 'inherit';
    overlay.style.cursor = 'pointer';
    overlay.style.background = 'rgba(0, 0, 0, 0)';
    overlay.style.display = 'block';

    overlay.addEventListener('click', triggerMailto);

    row.appendChild(overlay);
    console.log('[skio-upgrade] overlay appended for row', row);

    return true;
  }

  function wireButton() {
    var rows = document.querySelectorAll('.sc-4b34317c-1');
    var rewired = false;

    rows.forEach(function (row, index) {
      var button = row.querySelector('button[aria-label="Edit products"], button[data-skio-upgrade-wired="true"]');
      var labelSpan = row.querySelector('[data-testid="typography"]');

      if (!button && !labelSpan && row.dataset.skioUpgradeApplied !== 'true') {
        return;
      }

      var labelText = labelSpan && labelSpan.textContent ? labelSpan.textContent.trim().toLowerCase() : '';
      var buttonLabel = button && button.getAttribute('aria-label');
      var matchesOriginal = (labelText === 'edit products') || (buttonLabel && buttonLabel.toLowerCase() === 'edit products');
      var alreadyUpgraded = row.dataset.skioUpgradeApplied === 'true';

      if (!matchesOriginal && !alreadyUpgraded) {
        if (index < 5) {
          console.log('[skio-upgrade] skipping row', index, 'labelText:', labelText, 'buttonLabel:', buttonLabel);
        }
        return;
      }

      if (button) {
        button.dataset.skioUpgradeWired = 'true';
        button.setAttribute('aria-label', upgradeLabel);
        button.type = 'button';
      }

      if (labelSpan) {
        labelSpan.textContent = upgradeLabel;
      }

      row.dataset.skioUpgradeApplied = 'true';

      if (ensureOverlay(row)) {
        rewired = true;
        console.log('[skio-upgrade] overlay ensured for row', index);
      }
    });

    console.log('[skio-upgrade] wireButton completed. rewired?', rewired);
    return rewired;
  }

    function initObserver() {
        if (wireButton()) {
            return;
        }

        observer = new MutationObserver(function () {
            if (wireButton() && observer) {
                observer.disconnect();
                observer = null;
            }
        });

        observer.observe(document.body, {childList: true, subtree: true});
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
    } else {
        initObserver();
  }
})();

// Sticky PDP ATC (mobile bottom nav) -> submit main PDP form and sync loading state.
(function () {
    function isVisible(el) {
        return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
    }

    function findTargetButton() {
        var btn = document.querySelector('.custom_product_add_to_carts_main .js-product-form-submit-btn');
        if (btn && isVisible(btn)) return btn;
        var all = document.querySelectorAll('.js-product-form-submit-btn');
        for (var i = 0; i < all.length; i++) {
            if (isVisible(all[i])) return all[i];
        }
        return null;
    }

    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.trigger_cart');
        if (!trigger) return;
        if (e.stickyAtcHandled) return;
        e.stickyAtcHandled = true;
        e.preventDefault();

        var targetBtn = findTargetButton();
        if (trigger) {
            trigger.classList.add('loading');
            trigger.setAttribute('aria-disabled', 'true');
        }

        if (targetBtn) {
            var targetForm = targetBtn.closest('form');
            if (targetForm) {
                targetForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            } else {
                targetBtn.click();
            }
        }

        if (trigger && targetBtn) {
            var start = Date.now();
            var syncTimer = setInterval(function () {
                var isLoading = targetBtn.classList.contains('loading');
                if (!isLoading || Date.now() - start > 10000) {
                    trigger.classList.remove('loading');
                    trigger.removeAttribute('aria-disabled');
                    clearInterval(syncTimer);
                }
            }, 200);
        }
    });
})();

(function () {
  function getRollingLoopWidth(items, track) {
    if (!items || !items.length) return 0;
    var width = 0;
    var gapValue = 0;
    if (track) {
      var styles = window.getComputedStyle(track);
      gapValue = parseFloat(styles.columnGap || styles.gap || "0");
    }
    if (!Number.isFinite(gapValue)) {
      gapValue = 0;
    }
    items.forEach(function (item, index) {
      var rect = item.getBoundingClientRect();
      width += rect ? rect.width : item.offsetWidth || 0;
      if (index < items.length - 1) {
        width += gapValue;
      }
    });
    return Math.max(0, Math.round(width));
  }

  function cloneRollingItems(track, originals) {
    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-rolling-clone", "true");
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
          clone.removeAttribute(attr.name);
        }
      });
      track.appendChild(clone);
    });
  }

  function ensureRollingLoop(section) {
    if (!section) return;
    if (window.matchMedia("(max-width: 47.99em)").matches) return;

    var mask = section.querySelector("[data-marquee-mask]");
    var track = section.querySelector("[data-marquee-track]");
    if (!mask || !track) return;

    var maskWidth = mask.clientWidth;
    if (!maskWidth) return;

    var existingClones = track.querySelectorAll('[data-rolling-clone="true"], [aria-hidden="true"]');
    existingClones.forEach(function (node) {
      node.remove();
    });

    var originals = Array.prototype.slice.call(track.children).filter(function (item) {
      return item.getAttribute("aria-hidden") !== "true";
    });
    if (!originals.length) return;

    var loopWidth = getRollingLoopWidth(originals, track);
    if (!loopWidth) {
      if (section.dataset.rollingLoopRetry !== "true") {
        section.dataset.rollingLoopRetry = "true";
        setTimeout(function () {
          section.dataset.rollingLoopRetry = "false";
          ensureRollingLoop(section);
        }, 400);
      }
      return;
    }

    var originalsCopy = originals.slice();
    track.innerHTML = "";
    originalsCopy.forEach(function (item) {
      track.appendChild(item);
    });

    var sequenceWidth = getRollingLoopWidth(Array.prototype.slice.call(track.children), track);
    if (!sequenceWidth) {
      section.style.setProperty("--marquee-distance", loopWidth + "px");
      return;
    }

    while (sequenceWidth < maskWidth) {
      originalsCopy.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("data-rolling-clone", "true");
        Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
          if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
            clone.removeAttribute(attr.name);
          }
        });
        track.appendChild(clone);
      });
      sequenceWidth = getRollingLoopWidth(Array.prototype.slice.call(track.children), track);
      if (!sequenceWidth) break;
    }

    var sequenceNodes = Array.prototype.slice.call(track.children);
    sequenceNodes.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-rolling-clone", "true");
      Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
        if (attr && attr.name && attr.name.indexOf("data-shopify") === 0) {
          clone.removeAttribute(attr.name);
        }
      });
      track.appendChild(clone);
    });

    var totalWidth = track.scrollWidth;
    var marqueeDistance = totalWidth ? Math.round(totalWidth / 2) : sequenceWidth;
    section.style.setProperty("--marquee-distance", marqueeDistance + "px");
  }

  function initRollingLoop(root) {
    if (!root) return;
    var sections = root.querySelectorAll(".rolling-testimonials");
    sections.forEach(function (section) {
      ensureRollingLoop(section);
      if (section.dataset.rollingResizeInit === "true") return;
      if ("ResizeObserver" in window) {
        var mask = section.querySelector("[data-marquee-mask]");
        if (mask) {
          var observer = new ResizeObserver(function () {
            ensureRollingLoop(section);
          });
          observer.observe(mask);
          section.dataset.rollingResizeInit = "true";
        }
      }
    });
  }

  var resizeTimer = null;
  function handleResize() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function () {
      initRollingLoop(document);
    }, 150);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingLoop(document);
  });

  window.addEventListener("load", function () {
    initRollingLoop(document);
  });

  window.addEventListener("resize", handleResize);

  document.addEventListener("shopify:section:load", function (event) {
    initRollingLoop(event.target || document);
  });
})();

(function () {
  function activateRollingTestimonials(section) {
    if (!section || section.dataset.rollingAnimated === "true") return;

    var cards = section.querySelectorAll(".rolling-testimonials__item.anm");
    if (!cards.length) {
      section.dataset.rollingAnimated = "true";
      return;
    }

    function activateVisible() {
      var mask = section.querySelector("[data-marquee-mask]");
      var maskRect = mask ? mask.getBoundingClientRect() : null;
      cards.forEach(function (card) {
        var visible = true;
        if (maskRect) {
          var rect = card.getBoundingClientRect();
          visible =
            rect.right > maskRect.left &&
            rect.left < maskRect.right &&
            rect.bottom > maskRect.top &&
            rect.top < maskRect.bottom;
        }
        if (!visible) {
          card.classList.add("anm-skip");
        }
        card.classList.add("animated");
      });
      section.dataset.rollingAnimated = "true";
    }

    var mask = section.querySelector("[data-marquee-mask]");
    if (!("IntersectionObserver" in window) || !mask) {
      activateVisible();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            activateVisible();
            obs.disconnect();
            return;
          }
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(mask);
  }

  function initRollingTestimonials(root) {
    if (!root) return;
    var sections = root.querySelectorAll(".rolling-testimonials[data-rolling-animate=\"true\"]");
    sections.forEach(function (section) {
      activateRollingTestimonials(section);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingTestimonials(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initRollingTestimonials(event.target || document);
  });
})();

(function () {
  function initRollingTestimonialsSwipe(root) {
    if (!root) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var sections = root.querySelectorAll(".rolling-testimonials");
    sections.forEach(function (section) {
      if (section.dataset.rollingSwipeInit === "true") return;
      var useCssAuto = section.dataset.rollingCssAuto === "true";
      var pauseOnHover = section.dataset.pauseOnHover === "true";
      var stopOnInteract = window.matchMedia("(max-width: 47.99em)").matches || window.matchMedia("(pointer: coarse)").matches;
      var mask = section.querySelector("[data-marquee-mask]");
      var track = section.querySelector("[data-marquee-track]");
      if (!mask || !track) {
        section.dataset.rollingSwipeInit = "true";
        return;
      }

      if (!stopOnInteract) {
        section.dataset.rollingSwipeInit = "true";
        return;
      }

      if (useCssAuto) {
        track.style.animation = "none";
        track.style.transform = "translate3d(0, 0, 0)";
        section.dataset.rollingCssAuto = "false";
        useCssAuto = false;
      }

      function getLoopWidth() {
        var items = Array.prototype.slice.call(
          track.querySelectorAll('.rolling-testimonials__item:not([aria-hidden="true"])')
        );
        var fallbackWidth = Math.round(track.scrollWidth / 2);
        if (!items.length) return fallbackWidth;
        var styles = window.getComputedStyle(track);
        var gapValue = parseFloat(styles.columnGap || styles.gap || "0");
        if (!Number.isFinite(gapValue)) {
          gapValue = 0;
        }
        var width = 0;
        items.forEach(function (item, index) {
          var rect = item.getBoundingClientRect();
          width += rect ? rect.width : item.offsetWidth || 0;
          if (index < items.length - 1) {
            width += gapValue;
          }
        });
        return Math.max(0, Math.round(width || fallbackWidth || 0));
      }

      var loopWidth = getLoopWidth();
      if (!loopWidth) {
        if (section.dataset.rollingSwipeRetry !== "true") {
          section.dataset.rollingSwipeRetry = "true";
          setTimeout(function () {
            section.dataset.rollingSwipeRetry = "false";
            initRollingTestimonialsSwipe(root);
          }, 500);
        }
        return;
      }

      if (!section.dataset.rollingSwipePositioned) {
        mask.scrollLeft = loopWidth;
        section.dataset.rollingSwipePositioned = "true";
      }

      var speedSeconds = parseFloat(section.dataset.speedSeconds);
      if (!Number.isFinite(speedSeconds) || speedSeconds <= 0) {
        speedSeconds = 180;
      }
      var pxPerMs = loopWidth / (speedSeconds * 1000);

      function wrapScroll() {
        var maxScroll = track.scrollWidth - mask.clientWidth;
        if (mask.scrollLeft <= 1) {
          mask.scrollLeft += loopWidth;
        } else if (mask.scrollLeft >= maxScroll - 1) {
          mask.scrollLeft -= loopWidth;
        }
      }

      mask.addEventListener("scroll", wrapScroll, { passive: true });

      if (!useCssAuto && section.dataset.rollingAutoScrollInit !== "true") {
        var autoScrollActive = true;
        var autoScrollPaused = false;
        var autoScrollId = null;
        var lastTime = null;

        function updateLoopWidth() {
          var newWidth = getLoopWidth();
          if (!newWidth || newWidth === loopWidth) return;
          loopWidth = newWidth;
          pxPerMs = loopWidth / (speedSeconds * 1000);
          wrapScroll();
        }

        function stopAutoScroll() {
          if (!autoScrollActive) return;
          autoScrollActive = false;
          if (autoScrollId) {
            cancelAnimationFrame(autoScrollId);
          }
          section.dataset.rollingAutoScrollStopped = "true";
        }

        function step(ts) {
          if (!autoScrollActive || autoScrollPaused) {
            autoScrollId = requestAnimationFrame(step);
            return;
          }
          if (lastTime == null) {
            lastTime = ts;
          }
          var delta = ts - lastTime;
          lastTime = ts;
          mask.scrollLeft += pxPerMs * delta;
          wrapScroll();
          autoScrollId = requestAnimationFrame(step);
        }

        if (stopOnInteract) {
          mask.addEventListener("pointerdown", stopAutoScroll, { passive: true });
          mask.addEventListener("touchstart", stopAutoScroll, { passive: true });
          mask.addEventListener("wheel", stopAutoScroll, { passive: true });
        }
        if (pauseOnHover) {
          mask.addEventListener("mouseenter", function () {
            autoScrollPaused = true;
          });
          mask.addEventListener("mouseleave", function () {
            autoScrollPaused = false;
            lastTime = null;
          });
        }

        autoScrollId = requestAnimationFrame(step);
        section.dataset.rollingAutoScrollInit = "true";

        if ("ResizeObserver" in window && section.dataset.rollingSwipeResizeInit !== "true") {
          var observer = new ResizeObserver(function () {
            updateLoopWidth();
          });
          observer.observe(mask);
          observer.observe(track);
          section.dataset.rollingSwipeResizeInit = "true";
        }
      }

      section.dataset.rollingSwipeInit = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRollingTestimonialsSwipe(document);
  });

  window.addEventListener("load", function () {
    initRollingTestimonialsSwipe(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initRollingTestimonialsSwipe(event.target || document);
  });
})();

(function () {
  function getAnimClass(style) {
    switch (style) {
      case "fade":
        return "anm-fade";
      case "fade-up":
        return "anm-fadeInUp";
      case "slide-left":
        return "anm-slideLeft";
      case "slide-right":
        return "anm-slideRight";
      case "zoom-out":
        return "anm-zoomOut";
      default:
        return "anm-fadeInUp";
    }
  }

  function initSwipeGroupAnimations(root) {
    if (!root) return;
    var sections = root.querySelectorAll('.swipe-group-section[data-swipe-animate="true"]');
    sections.forEach(function (section) {
      if (section.dataset.swipeAnimInit === "true") return;
      var disableMobile = section.dataset.animDisableMobile === "true";
      if (disableMobile && window.matchMedia("(max-width: 749px)").matches) {
        section.dataset.swipeAnimInit = "true";
        return;
      }

      var content = section.querySelector("[data-swipe-content]");
      if (!content) {
        section.dataset.swipeAnimInit = "true";
        return;
      }

      var animClass = getAnimClass(section.dataset.animStyle || "fade-up");
      var duration = parseFloat(section.dataset.animDuration || "0.6");
      var delay = parseFloat(section.dataset.animDelay || "0");
      var stagger = parseFloat(section.dataset.animStagger || "0.06");
      var offset = parseFloat(section.dataset.animOffset || "24");
      var children = Array.prototype.slice.call(content.children);

      children.forEach(function (child, index) {
        child.classList.add("anm", animClass);
        child.style.setProperty("--duration", duration + "s");
        child.style.setProperty("--delay", delay + stagger * index + "s");
        child.style.setProperty("--offset", offset + "px");
      });

      function activateStaggered() {
        children.forEach(function (child, index) {
          var ms = (delay + stagger * index) * 1000;
          setTimeout(function () {
            child.classList.add("animated");
          }, ms);
        });
        section.dataset.swipeAnimActivated = "true";
      }

      var target = section.querySelector(".swipe-group-section__inner") || content;
      if (!("IntersectionObserver" in window) || !target) {
        activateStaggered();
      } else {
        var observer = new IntersectionObserver(
          function (entries, obs) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                activateStaggered();
                obs.disconnect();
                return;
              }
            }
          },
          { threshold: 0.2 }
        );
        observer.observe(target);
      }

      section.dataset.swipeAnimInit = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initSwipeGroupAnimations(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initSwipeGroupAnimations(event.target || document);
  });
})();

(function () {
  function setInlineVideoState(video, isPlaying) {
    if (!video) {
      return;
    }
    var wrapper = video.closest('[data-video-inline-wrapper]');
    if (!wrapper) {
      return;
    }
    var hasPlayed = wrapper.dataset.inlinePlayed === 'true';
    wrapper.classList.toggle('is-playing', isPlaying || hasPlayed);
  }

  function enableInlineVideoControls(video) {
    if (!video) {
      return;
    }
    var wrapper = video.closest('[data-video-inline-wrapper]');
    if (!wrapper || wrapper.dataset.inlineControlsReady === 'true') {
      return;
    }
    video.controls = true;
    wrapper.dataset.inlineControlsReady = 'true';
  }

  document.addEventListener(
    'play',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        var wrapper = event.target.closest('[data-video-inline-wrapper]');
        if (wrapper) {
          wrapper.dataset.inlinePlayed = 'true';
        }
        setInlineVideoState(event.target, true);
        enableInlineVideoControls(event.target);
      }
    },
    true
  );

  document.addEventListener(
    'pause',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        setInlineVideoState(event.target, false);
      }
    },
    true
  );

  document.addEventListener(
    'ended',
    function (event) {
      if (event.target && event.target.tagName === 'VIDEO') {
        setInlineVideoState(event.target, false);
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    var playButton = event.target.closest('.js-video-inline-play');
    if (!playButton) {
      return;
    }
    var wrapper = playButton.closest('[data-video-inline-wrapper]');
    if (!wrapper) {
      return;
    }
    var video = wrapper.querySelector('video');
    if (!video) {
      return;
    }
    event.preventDefault();
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        setInlineVideoState(video, false);
      });
    }
  });
})();

// Debug PDP navigation + loader timing from pill tray clicks.
// Enable via ?debug-pdp-load=1 or localStorage.debugPdpLoad = "true".
(function () {
  var params = new URLSearchParams(window.location.search || '');
  var debugEnabled = params.get('debug-pdp-load') === '1' || localStorage.getItem('debugPdpLoad') === 'true';

  if (!debugEnabled) {
    return;
  }

  var navKey = 'pdpNavStart';
  var navHrefKey = 'pdpNavHref';
  var startStamp = sessionStorage.getItem(navKey);

  function log(label) {
    var now = Math.round(performance.now());
    var delta = startStamp ? Math.round(Date.now() - Number(startStamp)) : null;
    if (delta !== null && Number.isFinite(delta)) {
      console.log('[pdp-load]', label + ' @' + now + 'ms', 'delta-from-click=' + delta + 'ms');
    } else {
      console.log('[pdp-load]', label + ' @' + now + 'ms');
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.pill-tray__pill');
    if (!link) return;
    sessionStorage.setItem(navKey, String(Date.now()));
    sessionStorage.setItem(navHrefKey, link.href || '');
    console.log('[pdp-load] pill-tray click', link.href || '');
  });

  document.addEventListener('DOMContentLoaded', function () {
    log('DOMContentLoaded');
  });

  window.addEventListener('load', function () {
    log('window.load');
  });

  var body = document.body;
  if (body) {
    var loadingClassRe = /(loading|is-loading|page-loading|page--loading|transition)/i;
    var sawLoadingClass = loadingClassRe.test(body.className || '');
    var classObserver = new MutationObserver(function () {
      var hasLoading = loadingClassRe.test(body.className || '');
      if (sawLoadingClass && !hasLoading) {
        log('body-loading-removed');
        classObserver.disconnect();
      } else if (!sawLoadingClass && hasLoading) {
        sawLoadingClass = true;
      }
    });
    classObserver.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  var loaderSelectors = [
    '.page-loader',
    '.loading-overlay',
    '.loading-screen',
    '.js-loading-overlay',
    '[data-page-loader]',
    '[data-loading-overlay]',
  ];
  var loaderState = {};

  function checkLoaders() {
    loaderSelectors.forEach(function (selector) {
      var node = document.querySelector(selector);
      if (!node) {
        if (loaderState[selector]) {
          log('loader-removed ' + selector);
          loaderState[selector] = null;
        }
        return;
      }
      if (!loaderState[selector]) {
        loaderState[selector] = node;
        log('loader-found ' + selector);
      }
      var isHidden = node.hidden || node.getAttribute('aria-hidden') === 'true';
      var style = window.getComputedStyle(node);
      var isDisplayNone = style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0');
      if (isHidden || isDisplayNone) {
        log('loader-hidden ' + selector);
        loaderState[selector] = null;
      }
    });
  }

  var domObserver = new MutationObserver(checkLoaders);
  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
  });
  checkLoaders();
})();

(function () {
  var V2_STORAGE_KEY = 'sht-side-cart-v2-enabled';
  var sideCartV3RuntimeOverride = null;

  function toBool(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function isV2JsToggleAllowed() {
    return toBool(window.__SHTAllowSideCartV2Toggle);
  }

  function isV3JsToggleAllowed() {
    return toBool(window.__SHTAllowSideCartV3Toggle);
  }

  function getConfiguredV2Default() {
    return toBool(window.__SHTSideCartV2Default);
  }

  function getConfiguredV3Default() {
    return toBool(window.__SHTSideCartV3Default);
  }

  function getStoredPreference(key, allowed) {
    if (!allowed) return null;
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function persistPreference(key, enabled, allowed) {
    if (!allowed) return false;
    try {
      window.localStorage.setItem(key, enabled ? 'true' : 'false');
      return true;
    } catch (error) {
      return false;
    }
  }

  function getActiveSideCartVersion() {
    var storedV2 = getStoredPreference(V2_STORAGE_KEY, isV2JsToggleAllowed());

    if (sideCartV3RuntimeOverride === true) return 'v3';
    if (!sideCartV3RuntimeOverride && getConfiguredV3Default()) return 'v3';
    if (storedV2 === 'true') return 'v2';
    if (storedV2 === 'false' || sideCartV3RuntimeOverride === false) return 'legacy';
    if (getConfiguredV2Default()) return 'v2';
    return 'legacy';
  }

  var cartTitleFrame = 0;
  var cartTitleWrapper = null;
  var cartTitleResizeObserver = null;

  function requestCartTitleFit() {
    if (cartTitleFrame) return;
    cartTitleFrame = window.requestAnimationFrame(function () {
      cartTitleFrame = 0;
      var drawer = document.querySelector('sht-cart-drwr[data-side-cart-v2-active="true"]');
      if (!drawer) return;
      drawer.querySelectorAll('.cart-drawer-v2__title').forEach(function (title) {
        if (!title.getBoundingClientRect().width) return;
        title.style.removeProperty('font-size');
        function fits() {
          return title.getBoundingClientRect().height <= parseFloat(getComputedStyle(title).lineHeight) * 2 + 0.5;
        }
        if (fits()) return;
        var low = 1;
        var high = parseFloat(getComputedStyle(title).fontSize);
        // Keep the complete name visible at the largest size that fits two lines.
        for (var i = 0; i < 9; i++) {
          var size = (low + high) / 2;
          title.style.fontSize = size + 'px';
          if (fits()) low = size;
          else high = size;
        }
        title.style.fontSize = (Math.floor(low * 10) / 10) + 'px';
      });
    });
  }

  function watchCartTitleWidth(drawer) {
    var wrapper = drawer.querySelector('.js-cart-drawer-wrapper');
    if (wrapper && wrapper !== cartTitleWrapper && window.ResizeObserver) {
      if (!cartTitleResizeObserver) cartTitleResizeObserver = new ResizeObserver(requestCartTitleFit);
      if (cartTitleWrapper) cartTitleResizeObserver.unobserve(cartTitleWrapper);
      cartTitleWrapper = wrapper;
      cartTitleResizeObserver.observe(wrapper);
    }
    requestCartTitleFit();
  }
  window.addEventListener('resize', requestCartTitleFit);
  if (document.fonts) document.fonts.ready.then(requestCartTitleFit);

  function applySideCartState() {
    var drawer = document.getElementById('shtCartDrawer');
    var version = getActiveSideCartVersion();
    var v2Active = version === 'v2';
    var v3Active = version === 'v3';
    var shellActive = v2Active || v3Active;

    document.documentElement.classList.toggle('side-cart-v2-active', v2Active);
    document.documentElement.classList.toggle('side-cart-v3-active', v3Active);
    document.body.classList.toggle('side-cart-v2-active', v2Active);
    document.body.classList.toggle('side-cart-v3-active', v3Active);

    if (!drawer) return version;

    drawer.setAttribute('data-side-cart-v2-active', shellActive ? 'true' : 'false');
    drawer.setAttribute('data-side-cart-v3-active', v3Active ? 'true' : 'false');
    drawer.setAttribute('data-side-cart-version', version);
    if (shellActive) watchCartTitleWidth(drawer);
    return version;
  }

  function setSideCartVersion(version) {
    if (version === 'v3') {
      sideCartV3RuntimeOverride = true;
      persistPreference(V2_STORAGE_KEY, false, isV2JsToggleAllowed());
    } else if (version === 'v2') {
      sideCartV3RuntimeOverride = false;
      persistPreference(V2_STORAGE_KEY, true, isV2JsToggleAllowed());
    } else {
      sideCartV3RuntimeOverride = false;
      persistPreference(V2_STORAGE_KEY, false, isV2JsToggleAllowed());
    }
    return applySideCartState();
  }

  function isSideCartV2Active() {
    return getActiveSideCartVersion() === 'v2';
  }

  function isSideCartV3Active() {
    return getActiveSideCartVersion() === 'v3';
  }

  window.SHTSideCartV2 = {
    enable: function () {
      return setSideCartVersion('v2');
    },
    disable: function () {
      if (!isSideCartV2Active()) return applySideCartState();
      return setSideCartVersion('legacy');
    },
    toggle: function (enabled) {
      if (typeof enabled === 'boolean') {
        return enabled ? setSideCartVersion('v2') : this.disable();
      }
      return isSideCartV2Active() ? this.disable() : this.enable();
    },
    isActive: function () {
      return isSideCartV2Active();
    },
    refresh: function () {
      return applySideCartState();
    }
  };

  window.SHTSideCartV3 = {
    enable: function () {
      if (window.SHTSideCartV2 && window.SHTSideCartV2.isActive && window.SHTSideCartV2.isActive()) {
        window.SHTSideCartV2.toggle(false);
      }
      return setSideCartVersion('v3');
    },
    disable: function () {
      if (!isSideCartV3Active()) return applySideCartState();
      return setSideCartVersion('legacy');
    },
    toggle: function (enabled) {
      if (typeof enabled === 'boolean') {
        return enabled ? this.enable() : this.disable();
      }
      return isSideCartV3Active() ? this.disable() : this.enable();
    },
    isActive: function () {
      return isSideCartV3Active();
    },
    refresh: function () {
      return applySideCartState();
    }
  };

  window.toggleSideCartV2 = function (enabled) {
    return window.SHTSideCartV2.toggle(enabled);
  };

  window.toggleSideCartV3 = function (enabled) {
    return window.SHTSideCartV3.toggle(enabled);
  };

  /* custom.js can load long after DOMContentLoaded (on non-product pages the
     layout defers it until first interaction), so apply the state immediately
     when the document is already parsed rather than waiting for an event that
     has been and gone. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySideCartState);
  } else {
    applySideCartState();
  }
  document.addEventListener('shopify:section:load', applySideCartState);
  window.addEventListener('load', applySideCartState);

  var sideCartObserver = new MutationObserver(function () {
    applySideCartState();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = document.getElementById('shtCartDrawer');
    if (!cartDrawer) return;

    sideCartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: false,
    });
  });
})();

/* Side cart upsell carousel.

   Two jobs, deliberately kept free of per-element state: the on/off gate
   (mirroring the side cart v2/v3 toggles) and the arrow buttons.

   .js-cart-drawer-wrapper has its innerHTML replaced wholesale on every cart
   change and there is no re-init hook afterwards, so anything holding a
   reference to a rail element would be pointing at a detached node the moment
   a line changes. Hence: the gate writes to <sht-cart-drwr>, which lives
   outside that wrapper, and the arrows are delegated off document with the
   scroll position read from the DOM each time. Nothing to tear down, nothing
   to rebuild. */
(function () {
  var RAIL_STORAGE_KEY = 'sht-cart-upsell-rail-enabled';

  function toBool(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function isRailJsToggleAllowed() {
    return toBool(window.__SHTAllowCartUpsellRailToggle);
  }

  function getConfiguredRailDefault() {
    return toBool(window.__SHTCartUpsellRailDefault);
  }

  function getStoredRailPreference() {
    if (!isRailJsToggleAllowed()) return null;
    try {
      return window.localStorage.getItem(RAIL_STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function persistRailPreference(enabled) {
    if (!isRailJsToggleAllowed()) return false;
    try {
      window.localStorage.setItem(RAIL_STORAGE_KEY, enabled ? 'true' : 'false');
      return true;
    } catch (error) {
      return false;
    }
  }

  function isCartUpsellRailEnabled() {
    var stored = getStoredRailPreference();
    if (stored === 'true') return true;
    if (stored === 'false') return false;
    return getConfiguredRailDefault();
  }

  function applyCartUpsellRailState() {
    var enabled = isCartUpsellRailEnabled();
    var drawer = document.getElementById('shtCartDrawer');
    if (drawer) {
      drawer.setAttribute('data-cart-upsell-rail-active', enabled ? 'true' : 'false');
    }
    return enabled;
  }

  function setCartUpsellRailEnabled(enabled) {
    persistRailPreference(enabled);
    return applyCartUpsellRailState();
  }

  window.SHTCartUpsellRail = {
    enable: function () {
      return setCartUpsellRailEnabled(true);
    },
    disable: function () {
      return setCartUpsellRailEnabled(false);
    },
    toggle: function (enabled) {
      if (typeof enabled === 'boolean') {
        return setCartUpsellRailEnabled(enabled);
      }
      return setCartUpsellRailEnabled(!isCartUpsellRailEnabled());
    },
    isActive: function () {
      return isCartUpsellRailEnabled();
    },
    refresh: function () {
      return applyCartUpsellRailState();
    }
  };

  window.toggleCartUpsellRail = function (enabled) {
    return window.SHTCartUpsellRail.toggle(enabled);
  };

  function getRailTrack(node) {
    if (!node || !node.closest) return null;
    var rail = node.closest('.cart-upsell-rail');
    return rail ? rail.querySelector('.js-cart-upsell-rail-track') : null;
  }

  /* The track resets to scrollLeft 0 on every re-render and the server marks
     the prev arrow disabled to match, so this only has to keep up with
     scrolling the shopper does themselves. */
  function updateRailArrows(track) {
    if (!track || !track.closest) return;
    var rail = track.closest('.cart-upsell-rail');
    if (!rail) return;

    var prev = rail.querySelector('.cart-upsell-rail__arrow--prev');
    var next = rail.querySelector('.cart-upsell-rail__arrow--next');
    /* a pixel of slack: fractional card widths mean scrollLeft rarely lands
       exactly on 0 or on the maximum */
    var maxScroll = track.scrollWidth - track.clientWidth;

    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target && event.target.closest
      ? event.target.closest('.js-cart-upsell-rail-arrow')
      : null;
    if (!arrow || arrow.disabled) return;

    event.preventDefault();

    var track = getRailTrack(arrow);
    if (!track) return;

    var slide = track.querySelector('.cart-upsell-rail__slide');
    var step = slide ? slide.getBoundingClientRect().width : track.clientWidth;
    var direction = arrow.getAttribute('data-direction') === 'prev' ? -1 : 1;
    var maxScroll = track.scrollWidth - track.clientWidth;
    var start = track.scrollLeft;
    var target = Math.max(0, Math.min(maxScroll, start + direction * step));
    var reduceMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });

    /* Some environments never start the smooth animation at all (it was dead
       across the whole page under automation, window.scrollBy included), which
       would leave the arrow looking broken. If nothing has moved shortly after
       the request, land it instantly instead. A real animation is well underway
       by then, so this does not fight one that is running. */
    window.setTimeout(function () {
      if (Math.abs(track.scrollLeft - start) < 1 && target !== start) {
        track.scrollLeft = target;
      }
      updateRailArrows(track);
    }, 240);
  });

  /* scroll does not bubble, so this listens on the capture phase — that is what
     lets one listener serve a rail that gets replaced on every cart update. */
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || !track.classList) return;
    if (!track.classList.contains('js-cart-upsell-rail-track')) return;
    updateRailArrows(track);
  }, { capture: true, passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCartUpsellRailState);
  } else {
    applyCartUpsellRailState();
  }
  document.addEventListener('shopify:section:load', applyCartUpsellRailState);
  window.addEventListener('load', applyCartUpsellRailState);
})();

/* Step 1 format chooser (Pouch / Box) — swap without reloading.

   The buttons are real links carrying ?variant=, so the feature works with no
   JS at all and stays correct if the two formats are ever priced differently.
   This upgrades that to an in-place swap when it is safe to do so.

   Safe means: both formats price every supply length identically, which Liquid
   asserts via data-prices-match. When that holds, the only per-format facts in
   the markup are each tab's variant id and selling plan, so rewriting those two
   attributes is a complete swap — the prices, save badges and per-day figures
   on screen are already right for either format. When it does not hold, this
   stands down and the link navigates, because a stale price is worse than a
   page load.

   Deliberately does NOT reorder or duplicate the supply rows: the widget's
   jQuery finds them by [data_tab="N"] and takes .first(), so two formats live
   in the DOM at once is exactly what breaks it. One format, swapped in place. */
(function () {
  function readFormatMap(row) {
    var host = row.closest('.custom_boc_subscripe_full, .custom_widget_subscription, body');
    var el = (host || document).querySelector('.js-atc-format-map');
    if (!el) return null;
    if (el.getAttribute('data-prices-match') !== 'true') return null;
    try {
      var parsed = JSON.parse(el.textContent);
      return parsed && parsed.formats ? parsed.formats : null;
    } catch (error) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.js-atc-format-row .pdp-format')
      : null;
    if (!button) return;

    var row = button.closest('.js-atc-format-row');
    var format = button.getAttribute('data-format');
    if (!row || !format) return;
    if (button.classList.contains('active')) {
      event.preventDefault();
      return;
    }

    var formats = readFormatMap(row);
    var tabs = formats && formats[format];
    /* no map, or prices differ -> let the href do it */
    if (!tabs) return;

    event.preventDefault();

    var scope = row.closest('.custom_boc_subscripe_full') || document;

    Object.keys(tabs).forEach(function (tab) {
      var entry = tabs[tab] || {};
      if (!entry.v) return;

      scope
        .querySelectorAll('.subscription_heading_member.months .subscription_heading_member_item[data_tab="' + tab + '"]')
        .forEach(function (item) {
          item.setAttribute('variant_id', entry.v);
          item.setAttribute('data-v2-base-variant-id', entry.v);
          if (entry.p) {
            item.setAttribute('selling_plan', entry.p);
            item.setAttribute('data-v2-base-selling-plan', entry.p);
          }
        });

      scope
        .querySelectorAll('.subscription_prices_item[data_tab="' + tab + '"]')
        .forEach(function (item) {
          item.setAttribute('variant_id', entry.v);
        });
    });

    /* the shared tile markup marks selection with .is-selected + aria-checked,
       not the .active/.aria-current the old bespoke pills used */
    row.querySelectorAll('.pdp-format').forEach(function (item) {
      var isActive = item === button;
      item.classList.toggle('is-selected', isActive);
      item.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });

    /* Re-click the live supply tab so the widget recomputes the hidden inputs,
       button total and per-day copy from the attributes just rewritten, rather
       than duplicating that arithmetic here. */
    var activeTab = scope.querySelector('.subscription_heading_member.months .subscription_heading_member_item.active[data_tab]');
    if (activeTab) activeTab.click();

    /* Keep the address bar honest so a refresh or share lands on the same
       format AND the same supply length. The tile's href is computed
       server-side against whatever was selected at render time, so read the
       live tab instead — otherwise a reload silently drops the shopper back to
       the shortest supply. */
    var liveVariant = activeTab && activeTab.getAttribute('variant_id');
    var href = liveVariant
      ? window.location.pathname + '?variant=' + liveVariant
      : button.getAttribute('href');
    if (href && window.history && window.history.replaceState) {
      try {
        window.history.replaceState({}, '', href);
      } catch (error) {
        /* cross-origin or unsupported — the swap already happened */
      }
    }
  });
})();
